// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
  background-size: 650px 500px;
  background-position: calc(100% - 2px) 100px;
  background: #e6dddd;
  color: #2b1d0f;
}

.category-heading {
  display: none;
}

.category-strip {
  display: none;
}

.mobile-top-bar {
  display: none;
  /* hide by default */
}

.whatsapp-float {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #25D366;
  color: white;
  font-size: 26px;
  padding: 12px;
  border-radius: 50%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.whatsapp-float:hover {
  transform: scale(1.1);
}

/* ===== TOP BAR ===== */
.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  height: 38px;
  z-index: 10000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #0b2747 0%, #154c85 100%);
  padding: 0 28px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 6px 18px rgba(8, 28, 52, 0.24);
}

.top-icon {
  margin-right: 6px;
  vertical-align: middle;
  font-size: 12px;
}

.top-bar a {
  color: #e6efff;
  text-decoration: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
  transition: color 0.2s ease;
}

.top-bar a:hover {
  color: #ffffff;
  text-decoration: none;
}

.top-left,
.top-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.top-left span,
.top-right span {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}

.divider {
  color: rgba(255, 255, 255, 0.35);
}

.header-item {
  background-color: #007bff;
  border-style: dashed;
}

.Navigation {
  position: fixed;
  top: 38px;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 9999;
  border-bottom: 1px solid #d7e0ea;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(10px);
}

body {
  padding-top: 122px;
}

/* ===== SCROLL DOWN (COMPACT MODE) ===== */
.Navigation.compact .search-container,
.Navigation.compact .login,
.Navigation.compact .header-right {
  display: none !important;
}

/* Center menu when compact */
.Navigation.compact .menu-items {
  justify-content: center;
  padding-left: 0;
  width: 100%;
}

/* ===== SMOOTH TRANSITION ===== */
.menu-search-compare {
  transition: all 0.25s ease;
}

/* Optional: slight shrink effect */
.Navigation.compact .menu-search-compare {
  grid-template-columns: 1fr;
  padding: 12px 28px;
}

.kebab-menu {
  display: none;
}

.menu-search-compare {
  padding: 14px 28px;
  display: grid;
  grid-template-columns: minmax(280px, 420px) 1fr auto auto;
  align-items: center;
  column-gap: 22px;
  position: relative;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  z-index: 20;
  background: rgba(255, 255, 255, 0.96);
}

/* Menu Items*/
.menu-items {
  display: flex;
  gap: 26px;
  justify-content: center;
  font-size: 16px;
  margin: 0;
  padding: 0;
  z-index: 1000;
  font-weight: 600;
}

.menu-items a {
  text-decoration: none;
  color: #132a45;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.menu-items a:hover {
  color: #0d5ea8;
  border-bottom-color: #0d5ea8;
  cursor: pointer;
}

.menu-items a:focus {
  color: #0d5ea8;
  outline: none;
}

.left-image {
  width: 150px;
  /* adjust size */
  height: 150px;
}

.login {
  color: #0f172a;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  border: 1px solid #cfd8e3;
  border-radius: 10px;
  padding: 10px 14px;
  background: #ffffff;
  transition: all 0.2s ease;
}

.login:hover {
  color: #0d5ea8;
  border-color: #0d5ea8;
  cursor: pointer;
}

.login:focus {
  color: #0d5ea8;
  outline: none;
}

.compare-wishlist {
  color: black;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 600;
}

.header-right i {
  margin-right: 5px;
}

.header-right a,
.header-right span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #0f172a;
  font-size: 14px;
  border: 1px solid #cfd8e3;
  border-radius: 10px;
  padding: 10px 12px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.header-badge {
  position: absolute;
  top: -8px;
  right: -10px;
  min-width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #e53935;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  padding: 0 4px;
  border: 1.5px solid #ffffff;
  box-sizing: border-box;
}

.header-right a,
.mobile-cart-link,
.mobile-bottom-nav .nav-item {
  position: relative;
}

.header-right .header-badge {
  top: -8px;
  right: -8px;
}

.header-right a:hover,
.header-right span:hover {
  color: #0d5ea8;
  border-color: #0d5ea8;
}

.compare-wishlist {
  display: flex;
  gap: 15px;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  gap: 12px;
}

.left-logo {
  position: static;
  width: 78px;
  height: 78px;
  object-fit: contain;
  pointer-events: auto;
}

.Search {
  width: 100%;
  padding: 12px 45px 12px 14px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  font-size: 15px;
  transition: all 0.2s ease;
  box-sizing: border-box;
  margin-top: 0;
}

.Search:focus {
  outline: none;
  border-color: #0d5ea8;
  box-shadow: 0 0 0 3px rgba(13, 94, 168, 0.12);
}

.search-button {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 17px;
  color: #5f6b7b;
}

.search-button:hover {
  color: #0d5ea8;
}

/* Browse Categories*/
.browse-categories {
  text-decoration: none !important;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 5px;
  margin-top: 70px;
  padding: 10px 5px;
  position: absolute;

  border-radius: 5px;
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
  color: black;
  cursor: pointer;
  border-color: transparent;
  transition: background-color 0.3s ease;
}

.browse-categories a {
  text-decoration: none;
  color: whitesmoke;
  font-size: 16px;
  font-weight: bold;
  transition: color 0.3s ease;
  font-family: Quicksand, sans-serif;
}

.browse-categories:hover {
  background-color: #29a56c;
  color: white;
}

.browse-categories i {
  font-size: 20px;
}

.dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.dropdown ul {
  list-style-type: none;
  margin: 0;
  padding: 10px 0;
}

.dropdown ul li a {
  text-decoration: none;
  color: black;
  padding: 10px 20px;
  display: block;
  transition: background-color 0.3s ease;
}

.dropdown ul li a:hover {
  background-color: lightgreen;
  color: black;
}

.extra-categories {
  display: none;
}

#toggle-more {
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
}

#toggle-more:hover {
  color: lightgreen;
  color: black;
}

.discount-text {
  position: absolute;
  top: 50%;
  left: 30px;
  transform: translateY(-110%);
  background: transparent;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  text-align: left;
  width: auto;
}

.original-price {
  text-decoration: line-through;
  color: red;
  font-size: 20px;
  gap: 10px;
}

.discounted-price {
  font-size: 22px;
  font-weight: bold;
  color: yellow;
  margin-left: 10px;
}

.discount-text h2 {
  font-size: 50px;
  font-weight: bold;
  color: #ffcc00;
}

.Banner-container {
  --hero-blue: #0b2d5c;
  --hero-accent: #f2a61f;
  border-radius: 22px;
  margin: 2rem auto 0;
  position: relative;
  width: min(96%, 1240px);
  height: clamp(360px, 62vh, 620px);
  overflow: hidden;
  background: radial-gradient(circle at top right, #f6faff 0%, #edf3fc 42%, #e6eef9 100%);
  box-shadow: 0 18px 45px rgba(9, 30, 66, 0.2);
}

/* Slideshow content */
.slideshow-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.slides {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform;
}

.slide {
  min-width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  isolation: isolate;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: transparent;
  transform: scale(1.02);
}

.slide::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(100deg,
      rgba(8, 18, 36, 0.6) 8%,
      rgba(8, 18, 36, 0.2) 46%,
      rgba(8, 18, 36, 0) 76%);
  pointer-events: none;
}

/* Arrow buttons for manual navigation */
.prev,
.next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.92);
  color: #173a69;
  height: 44px;
  width: 44px;
  cursor: pointer;
  border: 1px solid rgba(23, 58, 105, 0.2);
  border-radius: 50%;
  font-size: 20px;
  transition: all 0.25s ease;
  box-shadow: 0 8px 18px rgba(10, 31, 57, 0.16);
  z-index: 2;
}

.prev {
  left: 20px;
}

.next {
  right: 20px;
}

.mobile-bottom-nav {
  display: none;
}

/* Add hover effect for better visibility */
.prev:hover,
.next:hover {
  background: var(--hero-blue);
  color: #ffffff;
  border-color: transparent;
}

.banner-info {
  position: absolute;
  left: clamp(16px, 3vw, 32px);
  bottom: clamp(16px, 3.3vw, 34px);
  z-index: 2;
  color: #ffffff;
  padding: 14px 16px;
  border-radius: 14px;
  background: rgba(5, 14, 28, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(8px);
  max-width: min(80%, 520px);
}

.banner-info h3 {
  margin: 0 0 8px;
  font-size: clamp(1.05rem, 2vw, 1.6rem);
  line-height: 1.2;
  letter-spacing: 0.2px;
}

.banner-info p {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.banner-info .cut-price {
  text-decoration: line-through;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.95rem;
}

.banner-info .discounted-price {
  color: #ffce6b;
  font-weight: 700;
  font-size: clamp(1rem, 1.8vw, 1.2rem);
}

.banner-dots {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 14px;
  display: flex;
  gap: 8px;
  z-index: 3;
}

.banner-dot {
  width: 8px;
  height: 8px;
  border: none;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.52);
  padding: 0;
  cursor: pointer;
  transition: all 0.25s ease;
}

.banner-dot.active {
  width: 24px;
  background: linear-gradient(90deg, var(--hero-blue), var(--hero-accent));
}

@media screen and (max-width: 768px) {
  .Banner-container {
    width: 94%;
    margin-top: 1.2rem;
    height: clamp(240px, 46vw, 320px);
    border-radius: 14px;
  }

  .prev,
  .next {
    width: 36px;
    height: 36px;
    font-size: 16px;
    top: calc(50% - 8px);
  }

  .prev {
    left: 10px;
  }

  .next {
    right: 10px;
  }

  .banner-info {
    left: 10px;
    right: 10px;
    bottom: 10px;
    max-width: none;
    padding: 10px 12px;
  }

  .banner-info h3 {
    margin-bottom: 6px;
    font-size: 0.95rem;
  }

  .banner-info .cut-price,
  .banner-info .discounted-price {
    font-size: 0.88rem;
  }

  .banner-dots {
    bottom: 6px;
    gap: 6px;
  }
}

/* Featured Categories and product container*/
.product-container {
  text-align: center;
  color: black;
  margin-top: 20px;
  justify-content: center;
  gap: 10px;
}

.featured-categories {
  margin-top: 20px;
  justify-content: center;
}

.product-box-container {
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 15px;
  margin-top: 20px;
}

.product-box-container li {
  width: 150px;
  height: 150px;
}

.product-box-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#productSlider {
  display: flex;
  margin-left: 30px;
  gap: 20px;
  transition: transform 0.5s ease;
}

.product-item img {
  width: 100%;
  max-width: 300px;
}

.slider-wrapper {
  position: relative;
  overflow: hidden;
}

.prev-btn,
.next-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #068ce5;
  color: #fff;
  border: none;
  font-size: 24px;
  padding: 10px;
  cursor: pointer;
  border-radius: 5rem;
  height: 3rem;
  width: 3rem;
  z-index: 10;
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

/* Ads container styling*/
.product-item {
  width: 100%;

  padding-left: 50px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  margin-top: 50px;
}

.product-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 90px;
  background-color: whitesmoke;
  border-radius: 10px;

  /* gap: 10px; */
}

/* Add to Cart Button */
.add-to-cart-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 10px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
  text-align: center;
}

/* Image styling */
.product-item img {
  width: 100%;
  max-width: 300px;
  height: 130px;
  background-color: #ffffff;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-item img:hover {
  transform: translateY(-10px);
}

.product-name {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.product-price {
  font-size: 1rem;
  color: #333;
  margin-top: 10px;
}

/* Each individual box */
.product-box {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 30%;
  text-align: center;
  transition: transform 0.3s ease;
  gap: 10px;
  text-align: center;
  margin: 20px;
  border: 1px solid#ddd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 350px;
}

/* Hover effect for individual boxes */
.product-box:hover {
  transform: translateY(-10px);
}

h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.shop-btn {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 10px;
}

.shop-btn:hover {
  background-color: lightgreen;
}

.shop-btn:active {
  background-color: green;
}

.product-box img {
  width: 80%;
  height: auto;
  max-width: 300px;
  margin: 20px 0;
}

/* Popular-Product styling */
.popular-product-heading {
  color: black;
  margin-left: 10px;
  margin-top: 10px;
  font-size: 22px;
  font-weight: bold;
}

.column {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  gap: 15px;
}

.product-card {
  color: black;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;
  text-align: center;
  transition:
    transform 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out;

  width: 180px;
  position: relative;
  background-color: #fff;
}

.product-card:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
}

.product-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}

.product-name {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
  cursor: pointer;
}

.product-name:hover {
  color: green;
}

.product-price {
  font-size: 14px;
  margin-bottom: 10px;
  color: #333;
}

.product-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  position: absolute;
  bottom: 10px;
  width: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
}

.product-card:hover .product-actions {
  opacity: 1;
  pointer-events: auto;
}

.product-actions button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  transition:
    transform 0.3s ease-in-out,
    color 0.3s ease-in-out;
}

.product-actions button:hover {
  transform: scale(1.2);
  color: #555;
}

.cart-btn i {
  color: #068ce5;
}

.view-btn i {
  color: #2980b9;
}

.wishlist-btn i {
  color: #e74c3c;
}

/* Optional: Add subtle shadow on hover for buttons */
.product-actions button:hover i {
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.popular-product-heading {
  color: black;
  margin-left: 10px;
  margin-top: 10px;
}

.product-card:hover {
  transform: scale(1.05);
}

.product-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.product-name {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
}

.product-name:hover {
  color: green;
  cursor: pointer;
}

.product-price {
  font-size: 14px;
  margin-bottom: 10px;
}

.product-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  position: relative;
}

.product-actions button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  transition:
    opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;
  opacity: 0;
  pointer-events: none;
  transform: translateY(10px);
  color: #068ce5;
}

.product-actions:hover button {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.cart-btn:hover {
  color: gray;
}

.wishlist-btn i {
  color: #068ce5;
}

.view-btn i {
  color: #068ce5;
}

.column {
  display: flex;
  padding: 10px;
  gap: 10px;
  padding-left: 20px;
}

.heading-daily {
  color: black;
  margin-left: 10px;
  padding: 10px;
}

.ads-product-container {
  display: flex;
  gap: 70px;
  justify-content: center;
}

.product-box-ads {
  flex: 1 1;
  max-width: 300px;
  background-color: whitesmoke;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 400px;
  box-sizing: border-box;
  text-align: center;
  color: black;
  transition: transform 0.3s ease;
}

.product-box-ads:hover {
  transform: translateY(-10px);
}

.product-box-ads img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 5px;
}

.shop-now-btn {
  padding: 10px 20px;
  border: none;
  background-color: #068ce5;
  color: white;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.2s;
}

.shop-now-btn:hover {
  transform: scale(1.05);
}

/*best sell container*/
.best-sell {
  color: black;
  display: flex;
  gap: 10px;
}

.banner-text {
  color: black;
}

.content-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
  padding: 20px;
}

/* Fixed container */
.fixed-container {
  width: 300px;
  padding: 20px 30px;
  border: 1px solid #ddd;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  background: white;
  flex-shrink: 0;
  border-radius: 10px;
  transition: transform 0.5s ease-in-out;
  margin-left: 20px;
}

.fixed-container img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

.fixed-container:hover {
  transform: scale(1.05);
  scroll-behavior: smooth;
}

.carousel-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-top: 20px;
}

.carousel {
  display: flex;
  gap: 2px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 10px;
}

/* Individual Carousel Item */
.carousel-item {
  border-radius: 10px;
  position: relative;
  min-width: 200px;
  max-width: 200px;
  text-align: center;
  margin-right: 10px;
  height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.5s ease-in-out;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.carousel::-webkit-scrollbar {
  display: none;
}

.carousel-item:hover {
  transform: scale(1.05);
  border: 2px solid #1d0170;
}

.carousel-item img {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.5s ease-in-out;
}

.carousel-item h3 {
  margin: 10px 0;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 40px;
  word-break: break-word;
  padding: 0 5px;
}

/* Icons Container */
.product-icons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 5px;
}

.product-icons button {
  margin-bottom: 5px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  transition:
    opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;
  opacity: 0;
  pointer-events: none;
  transform: translateY(10px);
}

.product-icons:hover button {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.product-icons button:hover {
  color: #1d0170;
}

.wishlist-btn i {
  color: #068ce5;
}

.compare-btn i {
  color: grey;
}

.preview-btn i {
  color: #068ce5;
}

.add-to-cart-btn:hover {
  background-color: #1d0170;
}

/* Carousel Arrows */
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.arrow-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #068ce5;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 10;
  transition:
    background-color 0.3s ease,
    transform 0.3s ease;
}

.arrow-btn:hover {
  background-color: #1d0170;
  transform: scale(1.1);
}

.arrow-btn:first-of-type {
  left: 10px;
}

.arrow-btn:last-of-type {
  right: 10px;
}

/*Deals of the day*/
.deals-of-the-day {
  color: black;
  margin-left: 10px;
  margin-top: 40px;
}

.carousel-item {
  position: relative;
  text-align: center;
  padding: 10px;
  background: #fff;
  border-radius: 10px;
  margin: 0 10px;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.carousel-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

/* Hover icons container */
.product-icons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px 0;
}

.product-icons button {
  border: none;
  background: #f0f0f0;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s ease;
}

.product-icons button:hover {
  background: #ddd;
}

/* Text Add to Cart button below hover icons */
.text-add-to-cart-btn {
  display: inline-block;
  margin-top: 5px;
  padding: 6px 12px;
  background-color: #068ce5;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.text-add-to-cart-btn:hover {
  background-color: #1d0170;
}

.deals-container {
  display: flex;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 80%;
  margin-bottom: 20px;
  padding-left: 5px;
}

/*Deal of day */
.deals-container {
  display: flex;
  gap: 20px;
  margin: 20px 40px;
}

.deal-box:hover {
  transform: scale(1.05);
  scroll-behavior: smooth;
}

.deal-box {
  flex: 1 1;
  border: 1px solid #ddd;
  padding: 15px;
  text-align: center;
  border-radius: 10px;
  background: #fff;
  transition: transform 0.5s ease-in-out;
  color: black;
  justify-content: center;
}





.deal-image {
  display: block;
  margin: 0 auto;
  height: 200px;
  object-fit: cover;
}
.countdown {
  display: flex;
  justify-content: space-around;
  margin: 10px 0;
  color: black;
}

.countdown div span {
  font-weight: bold;
  font-size: 18px;
}

.deal-price {
  font-weight: bold;
  margin: 10px 0;
  color: black;
}

.deal-cart-btn {
  padding: 8px 15px;
  border: none;
  background: #068ce5;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.selling-product {
  display: flex;
  gap: 20px;
  margin-top: 40px;
}

.selling-column {
  flex: 1 1;
}

.small-product {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
}

.small-product img {
  width: 60px;
  height: 60px;
  object-fit: cover;
}

/* Container for all 4 categories in a row */
.selling-product {
  display: flex;
  gap: 20px;
  padding: 20px;
  flex-wrap: wrap;
}

/* Each category box */
.product-category {
  flex: 1 1;
  min-width: 250px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background-color: #fafafa;
  transition: transform 0.5s ease-in-out;
}

.product-category:hover {
  transform: scale(1.05);
  scroll-behavior: smooth;
}

/* Category title */
.category-title {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
}

/* Container for small product cards inside a category */
.small-product-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Single small product card */
.small-product-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px;
  transition: transform 0.2s;
}

.small-product-card:hover {
  transform: translateY(-2px);
}

/* Product image */
.small-product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

/* Product name */
.small-product-name {
  font-size: 14px;
  font-weight: 600;
  flex-basis: 70px;
  margin: 0;
  color: #333;
}

/* Product price */
.small-product-price {
  font-size: 13px;
  font-weight: 500;
  color: #e74c3c;
  flex-basis: 60px;
  margin: 0;
}

/* Product description */
.small-product-desc {
  font-size: 12px;
  color: #555;
  flex: 1 1;
  margin: 0;
}

/*banner-below-container*/
.Banner-container-below {
  margin: 20px auto;
  border-radius: 10px;
  position: relative;
  width: 95%;
  height: 450px;
  overflow: hidden;
  align-items: center;
  justify-content: center;

}

.ads-slider img{
height: auto;
width: 100%;
}
/*Tags */
.tags {
  display: flex;
  gap: 50px;
  color: black;
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 30px;
}

.tag {
  display: flex;
  gap: 5px;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.tag-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
  transition: transform 0.5s ease-in-out;
}

.tag-content:hover {
  transform: scale(1.05);
  scroll-behavior: smooth;
}

.tag-content span {
  margin-top: 40px;
  margin-left: 30px;
  font-weight: bold;
  display: flex;
  gap: 5px;
}

.tag-content p {
  margin: 5px 0 0;
  font-size: 14px;
  font-weight: normal;
  color: black;
}

.tag i {
  position: absolute;
}

/* Footer */
.blue-text {
  color: #3391ff;
}

.yellow-text {
  color: #f3bd29;
}

.footer {
  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);
  --footer-text: #e8f0f8;
  --footer-muted: #c7d5e3;
  --footer-border: rgba(255, 255, 255, 0.14);
  --footer-highlight: #f3bd29;
  margin: 70px 0 -12px;
  padding: 40px clamp(18px, 3vw, 42px) 18px;
  color: var(--footer-text);
  background: var(--footer-bg);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.footer-main {
  width: min(1240px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);
  gap: clamp(18px, 3vw, 36px);
  align-items: flex-start;
}

.footer-brand-block {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.footer-brand img {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.footer-brand h2 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(22px, 2.1vw, 28px);
  letter-spacing: 0.02em;
}

.footer-description {
  margin: 0;
  max-width: 34ch;
  color: var(--footer-muted);
  line-height: 1.65;
  font-size: 14px;
}

.footer-contact-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-contact-list a {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--footer-text);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
}

.footer-contact-list a:hover {
  color: var(--footer-highlight);
}

.footer-contact-list a svg {
  color: var(--footer-highlight);
  flex-shrink: 0;
}

.footer-link-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link-group h3,
.footer-social-block h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0.01em;
}

.footer-link-group a {
  color: var(--footer-muted);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
  transition: color 0.2s ease;
}

.footer-link-group a:hover {
  color: #ffffff;
}

.footer-social-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-social-block p {
  margin: 0;
  color: var(--footer-muted);
  line-height: 1.6;
  font-size: 14px;
}

.footer-social-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 10px;
}

.footer-social-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  border: 1px solid var(--footer-border);
  border-radius: 999px;
  color: #ffffff;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.06);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.footer-social-item:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.26);
}

.footer-bottom {
  width: min(1240px, 100%);
  margin: 28px auto 0;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: var(--footer-muted);
  font-size: 13px;
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  gap: 16px;
}

.footer-bottom-links a {
  color: var(--footer-muted);
  text-decoration: none;
}

.footer-bottom-links a:hover {
  color: #ffffff;
}

@media screen and (max-width: 1080px) {
  .footer-main {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}

@media screen and (max-width: 768px) {
  .footer {
    margin-top: 48px;
    padding: 30px 16px 90px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .footer-social-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
  }

  .footer-bottom-links {
    gap: 12px;
    flex-wrap: wrap;
  }
}

/* Mobile Bottom Navigation */


/* ===== Laptop View Only (1024px – 1440px) ===== */
@media screen and (min-width: 1024px) and (max-width: 1440px) {
  /* .menu-items {
    gap: 60px;
    padding-left: 220px;
    font-size: 17px;
  } */

  /* .search-container {
    width: 45%;
    margin-left: 25%;
  } */

  .Banner-container {
    max-width: 90%;
    height: 420px;
    margin-left: auto;
    margin-right: auto;
  }

  .product-box {
    width: 28%;
    height: 360px;
  }

  .Ads-product-container {
    justify-content: center;
    gap: 20px;
  }

  .carousel-container {
    max-width: 1000px;
    height: 380px;
  }

  .carousel-item {
    min-width: 220px;
    max-width: 220px;
  }

  .deals-container {
    width: 85%;
  }

  .selling-product {
    gap: 30px;
  }

  .tags {
    gap: 70px;
  }
}

.info-icon {
  margin-right: 8px;
  font-size: 16px;
}

.home {
  color: #4caf50;
}

.email {
  color: #ea4335;
}

.phone {
  color: #1877f2;
}

@media (max-width: 1366px) and (min-width: 769px) {
  .top-bar {
    padding: 0 16px;
  }

  .top-left,
  .top-right {
    gap: 8px;
  }

  .menu-search-compare {
    grid-template-columns: minmax(240px, 340px) 1fr auto auto;
    column-gap: 12px;
    padding: 12px 16px;
  }

  .menu-items {
    gap: 16px;
  }

  .menu-items a {
    font-size: 15px;
  }

  .login,
  .header-right a,
  .header-right span {
    padding: 9px 10px;
  }
}

@media (max-width: 1180px) and (min-width: 769px) {
  .menu-search-compare {
    grid-template-columns: minmax(220px, 300px) 1fr auto;
  }

  .login {
    display: none;
  }

  .header-right {
    gap: 8px;
  }

  .header-right a,
  .header-right span {
    font-size: 13px;
    padding: 8px 10px;
  }

  .menu-items {
    gap: 12px;
  }

  .menu-items a {
    font-size: 14px;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .top-bar {
    justify-content: flex-end;
    padding: 0 10px;
  }

  .top-left {
    display: none;
  }

  .top-right {
    width: 100%;
    justify-content: flex-end;
    gap: 6px;
  }

  .top-right > a:not(:last-of-type),
  .top-right > .divider:not(:last-child) {
    display: none;
  }

  .top-right a {
    font-size: 12px;
    font-weight: 600;
  }

  .menu-search-compare {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "search actions"
      "menu menu";
    row-gap: 10px;
    column-gap: 10px;
    padding: 10px 12px;
  }

  .search-container {
    grid-area: search;
    min-width: 0;
    gap: 8px;
  }

  .menu-items {
    grid-area: menu;
    justify-content: flex-start;
    overflow-x: auto;
    white-space: nowrap;
    gap: 14px;
    padding-bottom: 3px;
  }

  .menu-items::-webkit-scrollbar {
    display: none;
  }

  .header-right {
    grid-area: actions;
    justify-content: flex-end;
    gap: 6px;
  }

  .login {
    display: none;
  }

  .left-logo {
    width: 58px;
    height: 58px;
  }

  .Search {
    padding: 10px 38px 10px 12px;
    font-size: 14px;
  }

  .header-right a,
  .header-right span {
    width: 38px;
    height: 36px;
    padding: 0;
    font-size: 0;
    justify-content: center;
  }

  .fancy-icon {
    font-size: 15px;
    margin: 0;
  }
}

@media (max-width: 768px) {

  /* Hide desktop nav, show mobile bottom nav */
  .Navigation,
  .top-bar {
    display: none;
  }

  html,
  body {
    max-width: 100%;
    overflow-x: hidden;
  }

  * {
    box-sizing: border-box;
  }

  .kebab-menu {
    display: block;
    font-size: 30px;
    cursor: pointer;
    position: fixed;
    top: 15px;
    right: 20px;
    z-index: 10001;
    color: #068ce5;

  }

  .mobile-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    padding: 10px 8px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10002;
    gap: 6px;
    border-bottom: 1px solid #dbe4ee;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
  }

  .mobile-logo {
    height: 38px;
    flex-shrink: 0;
  }

  .mobile-quick-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }

  .mobile-phone-link
{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border: 1px solid #d5e1ee;
    border-radius: 8px;
    background: #f7fbff;
    color: #16314d;
    min-height: 34px;
  }
  .deal-image{
    width: 100%;
    height: 100%;
  }

  .mobile-phone-link {
    gap: 5px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .mobile-cart-link {
    width: 34px;
  }

  .mobile-cart-link .header-badge,
  .mobile-bottom-nav .header-badge {
    top: -7px;
    right: -9px;
    border-color: #ffffff;
  }

  .mobile-search-wrapper {
    flex: 1 1;
    display: flex;
    gap: 5px;
    margin: 0;
    min-width: 0;
  }

  .mobile-search {
    flex: 1 1;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #cfdae6;
    background: #f7f9fc;
    font-size: 14px;
  }

  .mobile-search-btn {
    background: #0d5ea8;
    color: #ffffff;
    border: 1px solid #0d5ea8;
    padding: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-menu-btn {
    font-size: 26px;
    color: #16314d;
    cursor: pointer;
    flex-shrink: 0;
    margin-right: 2px;
    font-weight: bold;
  }

  @media (max-width: 400px) {
    .mobile-phone-link span {
      display: none;
    }

    .mobile-phone-link {
      width: 34px;
      padding: 0;
    }

    .mobile-logo {
      height: 34px;
    }
  }

  .mobile-drawer {
    position: fixed;
    top: 0;
    right: 0;
    width: 82%;
    height: 100%;
    background: #f8fafd;
    z-index: 10003;
    overflow-y: auto;
    padding: 16px;
    padding-top: 74px;
    padding-bottom: 3rem;
    transform: translateX(100%);
    transition: transform 0.25s ease-in-out;
    box-shadow: -12px 0 30px rgba(15, 23, 42, 0.16);
  }

  .mobile-drawer.open {
    transform: translateX(0);
  }

  body {
    padding-top: 64px;
    padding-bottom: 70px;
  }

  /* Login Card */
  .login-card {
    background: linear-gradient(135deg, #0d5ea8 0%, #1e73bf 100%);
    color: white;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    margin-left: 0;
  }

  .login-card h3 {
    margin: 0;
    font-size: 18px;
  }

  .login-card p {
    margin: 4px 0 0;
    font-size: 14px;
  }

  .login-btn {
    background: #0f172a;
    color: white;
    padding: 8px 16px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: bold;
  }

  /* Sections */
  .menu-section {
    background: white;
    border-radius: 12px;
    margin-bottom: 15px;
    padding: 10px 0;
    border: 1px solid #e4eaf2;
  }

  .menu-section h4 {
    margin: 0;
    padding: 10px 15px;
    font-size: 14px;
    color: #666;
  }

  /* Items */
  .menu-item {
    display: flex;
    justify-content: space-between;
    padding: 12px 15px;
    text-decoration: none;
    color: #333;
    border-top: 1px solid #eee;
    font-size: 15px;
  }

  .menu-item:first-of-type {
    border-top: none;
  }

  .menu-item:hover {
    background: #f3f8ff;
  }

  .mobile-bottom-nav {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #ffffff;
    border-top: 1px solid #d9e2ec;
    justify-content: space-around;
    align-items: center;
    padding: 10px 5px;
    z-index: 9999;
    box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.08);
  }

  .mobile-bottom-nav .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #20354d;
    text-decoration: none;
    gap: 2px;
  }

  .mobile-bottom-nav .nav-item svg {
    font-size: 18px;
    margin-bottom: 2px;
  }

  body {
    padding-bottom: 70px;
  }

  /* Search full width */
  .search-container {
    width: 95%;
    margin: 10px auto;
  }

  .Banner-container {
    height: 250px;
    margin: 10px auto;
    width: 95%;
  }

  /* Featured categories slider → horizontal scroll */
  .product-box-container {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 10px;
    padding: 20px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .product-item {
    min-width: 120px;
    flex-shrink: 0;
    scroll-snap-align: start;
    cursor: pointer;
  }

  /* Ads → stack nicely */
  .ads-product-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }

  .product-box-ads {
    width: 90%;
    height: auto;
    cursor: pointer;
  }

  /* Popular products → grid (2 per row) */
  .column {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 35px;
  }

  .popular-product-heading h2 {
    margin-left: 10px;
    padding: 10px;
  }

  .product-card {
    width: 100%;
    cursor: pointer;
  }

  /* Best sell section */
  .best-sell {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  /* Fixed container for padding */
  .fixed-container {
    width: 90%;
    margin: auto;
  }

  /* Deals → stack vertically */
  .deals-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 10px 0;
    gap: 15px;
  }

  /* Selling categories stacked */
  .selling-product {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .tags {
    flex-direction: column;
    gap: 15px;
  }

  .product-box-ads {
    display: none;
  }

  .fixed-container {
    display: none;
  }

  .whatsapp-float {
    margin-bottom: 50px;
    margin-right: -10px;
  }

  .category-heading {
    color: black;
    margin-left: 5px;
    display: block;
  }

  .category-strip {
    display: flex;
    overflow-x: auto;
    gap: 12px;
    padding: 10px;
  }

  .category-box {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    padding: 10px;
    background: #f8f8f8;
    border-radius: 12px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    text-align: center;
    color: black;
  }

   .Banner-container-below {
    margin-top: 24px;
    border-radius: 18px;
    border: 1px solid var(--border-soft);
    box-shadow: var(--shadow-soft);
    height: auto;
  }

.Banner-container-below img{
    height: 100%;
    width: 100%;
  }

  .category-box p {
    font-size: 12px;
    margin-top: 5px;
    color: #333;
  }

  .category-box:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  .category-box-link {
    text-decoration: none;
  }
}

  /* ===== Homepage Professional Polish ===== */
  :root {
    --home-bg: #f4f7fb;
    --surface: #ffffff;
    --surface-soft: #f8fbff;
    --text-strong: #11253d;
    --text-muted: #607086;
    --border-soft: #deebf7;
    --brand: #0f62ad;
    --brand-dark: #0a4f8f;
    --accent: #f5b93f;
    --shadow-soft: 0 10px 26px rgba(17, 37, 61, 0.08);
    --shadow-raise: 0 18px 36px rgba(17, 37, 61, 0.14);
  }

  body {
    background: radial-gradient(circle at 20% 0%, #ffffff 0%, #f1f6fd 38%, #edf3fb 100%);
    color: var(--text-strong);
  }

  .featured-categories,
  .popular-product-heading,
  .heading-daily,
  .deals-of-the-day,
  .category-heading {
    width: min(96%, 1240px);
    margin: 36px auto 12px;
    padding: 0;
    color: var(--text-strong);
    font-size: clamp(1.2rem, 1.8vw, 1.8rem);
    font-weight: 750;
    letter-spacing: 0.2px;
  }

  .product-container,
  .ads-product-container,
  .column,
  .best-sell,
  .deals-container,
  .selling-product,
  .tags,
  .Banner-container-below,
  .category-strip {
    width: min(96%, 1240px);
    margin-left: auto;
    margin-right: auto;
  }

  .product-container {
    margin-top: 8px;
  }

  .slider-wrapper {
    background: var(--surface);
    border: 1px solid var(--border-soft);
    border-radius: 18px;
    box-shadow: var(--shadow-soft);
    padding: 16px 12px;
  }

  .product-item {
    margin-top: 0;
    padding: 0;
  }

  .product-info {
    width: 100%;
    margin-bottom: 0;
    background: transparent;
    border-radius: 0;
  }

  #productSlider {
    margin-left: 0;
    gap: 14px;
  }

  .product-item img {
    border-radius: 12px;
    background: #ffffff;
  }

  .ads-product-container {
    gap: 20px;
    margin-top: 20px;
  }

  .product-box-ads,
  .product-card,
  .fixed-container,
  .carousel-item,
  .deal-box,
  .product-category,
  .small-product-card,
  .tag {
    border: 1px solid var(--border-soft);
    box-shadow: var(--shadow-soft);
    border-radius: 16px;
    background: var(--surface);
  }

  .product-box-ads:hover,
  .product-card:hover,
  .fixed-container:hover,
  .carousel-item:hover,
  .deal-box:hover,
  .product-category:hover,
  .small-product-card:hover {
    transform: translateY(-6px);
    box-shadow: var(--shadow-raise);
  }

  .product-box-ads {
    max-width: 350px;
    height: 420px;
  }

  .product-box-ads img {
    border-radius: 12px;
  }

  .column {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 2rem;
    padding: 6px 0;

  }

  .product-card {
    width: 100%;
    min-height: 280px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .product-name,
  .small-product-name,
  .category-title {
    color: var(--text-strong);
  }

  .product-price,
  .small-product-price,
  .deal-price {
    color: #0f4c86;
    font-weight: 700;
  }

  .product-actions {
    margin-top: auto;
    padding-top: 10px;
  }

  .product-actions button {
    background: var(--surface-soft);
    border: 1px solid var(--border-soft);
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }

  .product-actions button:hover {
    background: #edf4ff;
    border-color: #bfd6ee;
  }

  .best-sell {
    align-items: stretch;
    gap: 18px;
  }

  .fixed-container {
    margin-left: 0;
    width: 330px;
  }

  .fixed-container h3,
  .carousel-item h3,
  .deal-box h3 {
    margin: 8px 0 6px;
    color: var(--text-strong);
  }

  .carousel {
    gap: 12px;
    padding: 8px 10px;
  }

  .carousel-item {
    min-width: 220px;
    max-width: 220px;
    height: 360px;
  }

  .arrow-btn,
  .prev-btn,
  .next-btn {
    background: rgba(255, 255, 255, 0.95);
    color: var(--brand-dark);
    border: 1px solid #bdd5ed;
    box-shadow: 0 8px 18px rgba(17, 37, 61, 0.12);
  }

  .arrow-btn:hover,
  .prev-btn:hover,
  .next-btn:hover {
    background: var(--brand);
    color: #ffffff;
    border-color: transparent;
  }

  .deals-container {
    margin-top: 12px;
    margin-bottom: 0;
  }

  .deal-box {
    padding: 16px;
  }

  .deal-image {
    border-radius: 12px;
  }

  .countdown {
    background: var(--surface-soft);
    border: 1px solid var(--border-soft);
    border-radius: 12px;
    padding: 8px;
  }

  .countdown div span {
    color: var(--brand-dark);
  }

  .selling-product {
    gap: 14px;
    padding: 0;
    margin-top: 24px;
  }

  .product-category {
    background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  }

  .category-title {
    border-bottom: 1px solid var(--border-soft);
  }

  .small-product-card {
    gap: 12px;
    padding: 10px;
  }

  .small-product-desc {
    color: var(--text-muted);
  }

  .Banner-container-below {
    margin-top: 24px;
    border-radius: 18px;
    border: 1px solid var(--border-soft);
    box-shadow: var(--shadow-soft);
  }
  
  .tags {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 14px;
    margin-top: 18px;
    margin-bottom: 10px;
    margin-left: auto;
  }

  .tag {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px;
  }

  .tag i {
    position: static;
    font-size: 20px;
    margin-top: 2px;
  }

  .tag-content span {
    margin: 0;
    font-size: 15px;
    color: var(--text-strong);
  }

  .tag-content p {
    margin: 0;
    line-height: 1.45;
    color: var(--text-muted);
  }

  .shop-now-btn,
  .deal-cart-btn,
  .text-add-to-cart-btn {
    background: linear-gradient(120deg, var(--brand) 0%, var(--brand-dark) 100%);
    color: #ffffff;
    border: none;
    border-radius: 10px;
    font-weight: 650;
  }

  .shop-now-btn:hover,
  .deal-cart-btn:hover,
  .text-add-to-cart-btn:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  @media (max-width: 1024px) {
    .tags {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .best-sell {
      flex-direction: column;
    }

    .fixed-container {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .featured-categories,
    .popular-product-heading,
    .heading-daily,
    .deals-of-the-day,
    .category-heading {
      width: 94%;
      margin-top: 24px;
      margin-bottom: 10px;
      font-size: 1.15rem;
    }

    .product-container,
    .ads-product-container,
    .column,
    .best-sell,
    .deals-container,
    .selling-product,
    .tags,
    .Banner-container-below,
    .category-strip {
      width: 94%;
    }

    .slider-wrapper {
      border-radius: 14px;
      padding: 12px 8px;
    }

    .column {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px;
    }

    .product-card {
      min-height: 250px;
      padding: 10px;
    }

    .carousel-item {
      min-width: 190px;
      max-width: 190px;
    }

    .deals-container {
      gap: 12px;
    }

    .tags {
      grid-template-columns: 1fr;
      gap: 10px;
      margin-bottom: 18px;
    }
  }

  /* ===== Premium Refinement Pass ===== */
  body {
    font-family: "Manrope", "Segoe UI", "Poppins", sans-serif;
  }

  .featured-categories,
  .popular-product-heading,
  .heading-daily,
  .deals-of-the-day,
  .category-heading {
    position: relative;
    padding-bottom: 6px;
  }

  .featured-categories::after,
  .popular-product-heading::after,
  .heading-daily::after,
  .deals-of-the-day::after,
  .category-heading::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 68px;
    height: 3px;
    border-radius: 99px;
    background: linear-gradient(90deg, var(--brand) 0%, var(--accent) 100%);
    opacity: 0.9;
  }

  .featured-categories,
  .popular-product-heading,
  .heading-daily,
  .deals-of-the-day {
    text-transform: none;
    letter-spacing: 0.25px;
  }

  .product-card,
  .product-box-ads,
  .deal-box,
  .carousel-item,
  .product-category,
  .small-product-card,
  .fixed-container {
    transition:
      transform 0.25s ease,
      box-shadow 0.25s ease,
      border-color 0.25s ease;
  }

  .product-card:hover,
  .product-box-ads:hover,
  .deal-box:hover,
  .carousel-item:hover,
  .product-category:hover,
  .small-product-card:hover,
  .fixed-container:hover {
    border-color: #c5dbef;
  }

  .product-card {
    overflow: hidden;
  }

  .product-image,
  .deal-image,
  .product-box-ads img,
  .small-product-image,
  .carousel-item img,
  .fixed-container img {
    background: #f4f8fe;
  }

  .product-name,
  .small-product-name {
    line-height: 1.35;
  }

  .product-name:hover {
    color: var(--brand);
  }

  .product-actions {
    position: static;
    opacity: 1;
    pointer-events: auto;
    justify-content: center;
    gap: 8px;
  }

  .product-card:hover .product-actions {
    opacity: 1;
  }

  .product-actions button {
    transform: none;
  }

  .product-actions button:hover {
    transform: translateY(-1px);
  }

  .product-icons {
    margin-top: 8px;
  }

  .product-icons button {
    opacity: 1;
    pointer-events: auto;
    transform: none;
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: #f2f7fe;
    border: 1px solid #d7e6f5;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .product-icons button:hover {
    background: #e6f0fb;
    border-color: #bfd5eb;
  }

  .arrow-btn,
  .prev,
  .next,
  .prev-btn,
  .next-btn {
    backdrop-filter: blur(3px);
  }

  .shop-now-btn,
  .deal-cart-btn,
  .text-add-to-cart-btn {
    min-height: 38px;
    letter-spacing: 0.2px;
  }

  .text-add-to-cart-btn {
    width: 100%;
  }

  .deal-box {
    text-align: left;
  }

  .deal-box h3,
  .deal-price,
  .deal-cart-btn {
    margin-left: 4px;
  }

  .countdown {
    margin: 12px 0;
  }

  .countdown div {
    min-width: 52px;
    text-align: center;
  }

  .countdown p {
    margin: 2px 0 0;
    font-size: 11px;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .product-category {
    box-shadow: 0 10px 24px rgba(17, 37, 61, 0.06);
  }

  .small-product-cards {
    gap: 8px;
  }

  .small-product-card {
    align-items: flex-start;
  }

  .small-product-desc {
    line-height: 1.35;
  }

  .tag {
    align-items: center;
  }

  .tag-content {
    gap: 3px;
  }

  .tag-content p {
    font-size: 13px;
  }

  @media (max-width: 768px) {
    .product-actions {
      gap: 6px;
    }

    .product-actions button,
    .product-icons button {
      width: 32px;
      height: 32px;
      border-radius: 8px;
    }

    .deal-box {
      text-align: center;
    }

    .deal-box h3,
    .deal-price,
    .deal-cart-btn {
      margin-left: 0;
    }
  }

  /* Featured category slider: smooth infinite track */
  .slider-wrapper {
    /* --featured-gap: 14px; */
    --featured-visible: 5;
  }

  #productSlider {
    display: flex;
    gap: 10px;
    list-style: none;
    margin: 0;
    padding: 0;
    will-change: transform;
  }

  .product-slider .product-item {
    flex: 0 0 calc((100% - (var(--featured-gap) * (var(--featured-visible) - 1))) / var(--featured-visible));
    width: auto;
  }

  .product-slider .product-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .featured-product-name {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.35;
    text-align: center;
    color: var(--text-strong);
    min-height: 2.6em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .featured-product-price {
    margin: 0;
    font-size: 0.92rem;
    font-weight: 700;
    color: var(--brand-dark);
  }

  .product-box-container {
    overflow: hidden;
  }

  @media (max-width: 1024px) {
    .slider-wrapper {
      --featured-visible: 3;
    }
  }

  @media (max-width: 768px) {
    .slider-wrapper {
      --featured-visible: 2;
      --featured-gap: 10px;
    }

    .featured-product-name {
      font-size: 0.86rem;
      min-height: 2.4em;
    }

    .featured-product-price {
      font-size: 0.84rem;
    }
  }

/* Featured section: left aligned + premium container */
.featured-section {
  text-align: left;
  margin-top: 16px;
}

.featured-section .featured-categories {
  width: 100%;
  margin: 0 0 14px;
  text-align: left;
}

.featured-slider-shell {
  position: relative;
  padding: 20px 44px;
  border-radius: 20px;
  border: 1px solid #d7e5f4;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  box-shadow:
    0 18px 36px rgba(12, 33, 58, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.featured-section .product-box-container {
  margin-top: 0;
}

.featured-section .product-slider .product-item {
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e1ecf8;
  padding: 10px;
  box-shadow: 0 8px 20px rgba(15, 41, 71, 0.06);
}

.featured-section .product-slider .product-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 28px rgba(15, 41, 71, 0.14);
}

.featured-section .featured-product-name,
.featured-section .featured-product-price {
  text-align: left;
  width: 100%;
}

.featured-section .featured-product-price {
  margin-top: 2px;
}

@media (max-width: 768px) {
  .featured-section .featured-categories {
    width: 100%;
    margin-bottom: 10px;
  }

  .featured-slider-shell {
    padding: 14px 34px;
    border-radius: 14px;
  }

  .featured-section .product-slider .product-item {
    padding: 8px;
  }
  .close-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  background: transparent;
  border: none;
  font-size: 22px;
  cursor: pointer;
}
}

/* Body atmosphere inspired by modern electronics storefronts */
body {
  background-color: #eef4fb;
  background-image:
    radial-gradient(circle at 12% 6%, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 34%),
    radial-gradient(circle at 90% 14%, rgba(189, 218, 245, 0.46) 0%, rgba(189, 218, 245, 0) 36%),
    radial-gradient(circle at 86% 86%, rgba(215, 231, 248, 0.4) 0%, rgba(215, 231, 248, 0) 38%),
    linear-gradient(180deg, #f9fcff 0%, #f1f6fd 52%, #edf3fb 100%);
  background-attachment: fixed;
  color: #13283f;
}`, "",{"version":3,"sources":["webpack://./src/components/HomePage/homepage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;EAC7D,eAAe;EACf,iDAAiD;EACjD,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,gCAAgC;EAChC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;;;EAGE,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,qCAAqC;AACvC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;EAElB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,uFAAuF;EACvF,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;6BAG2B;EAC3B,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,2CAA2C;AAC3C;;EAEE,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,UAAU;EACV,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,wEAAwE;AAC1E;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;AACF;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,WAAW;;EAEX,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB;;+BAE6B;;EAE7B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf;;0BAEwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf;;8BAE4B;EAC5B,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;EAC3C,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,2CAA2C;EAC3C,sCAAsC;EACtC,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf;;8BAE4B;EAC5B,UAAU;EACV,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX;;uBAEqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,uBAAuB;AACzB;;;;;;AAMA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,WAAW;EACX,SAAO;EACP,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;AACA,YAAY;AACZ,WAAW;AACX;AACA,QAAQ;AACR;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2EAA2E;EAC3E,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;EACzC,yBAAyB;EACzB,4BAA4B;EAC5B,+CAA+C;EAC/C,6CAA6C;EAC7C,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,sGAAsG;EACtG,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC;;;0BAGwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA,6BAA6B;;;AAG7B,mDAAmD;AACnD;EACE;;;;KAIG;;EAEH;;;KAGG;;EAEH;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,yDAAyD;IACzD,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,QAAQ;EACV;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0CAA0C;IAC1C;;iBAEa;IACb,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;;EAEE,6CAA6C;EAC7C;;IAEE,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,eAAe;IACf,SAAS;IACT,WAAW;IACX,cAAc;IACd,cAAc;;EAEhB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,cAAc;IACd,QAAQ;IACR,gCAAgC;IAChC,6CAA6C;EAC/C;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;;IAEE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAS;IACT,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,QAAQ;IACR,SAAS;IACT,YAAY;EACd;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,WAAW;MACX,UAAU;IACZ;;IAEA;MACE,YAAY;IACd;EACF;;EAEA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,2BAA2B;IAC3B,uCAAuC;IACvC,+CAA+C;EACjD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA,eAAe;EACf;IACE,6DAA6D;IAC7D,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA,aAAa;EACb;IACE,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA,UAAU;EACV;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,8CAA8C;EAChD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA,sBAAsB;EACtB;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,UAAU;EACZ;;EAEA,mDAAmD;EACnD;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,wBAAwB;IACxB,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;;EAEA,wCAAwC;EACxC;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,gCAAgC;EAChC;IACE,UAAU;IACV,YAAY;EACd;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,SAAS;EACX;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;EACd;;GAEC;IACC,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,8BAA8B;IAC9B,YAAY;EACd;;AAEF;IACI,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,qBAAqB;EACvB;AACF;;EAEE,6CAA6C;EAC7C;IACE,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,iDAAiD;IACjD,kDAAkD;EACpD;;EAEA;IACE,oFAAoF;IACpF,yBAAyB;EAC3B;;EAEA;;;;;IAKE,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;IACV,yBAAyB;IACzB,uCAAuC;IACvC,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;;;;;;;;;IASE,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,oCAAoC;IACpC,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;;;;;;;;IAQE,oCAAoC;IACpC,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;;;;;;;IAOE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,cAAc;;EAEhB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;;;IAGE,yBAAyB;EAC3B;;EAEA;;;IAGE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;;;IAGE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;;;IAGE,qCAAqC;IACrC,wBAAwB;IACxB,yBAAyB;IACzB,6CAA6C;EAC/C;;EAEA;;;IAGE,wBAAwB;IACxB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;IAC/B,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;;;IAGE,4EAA4E;IAC5E,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;;IAGE,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE;MACE,gDAAgD;IAClD;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE;;;;;MAKE,UAAU;MACV,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;;;;;;;;;MASE,UAAU;IACZ;;IAEA;MACE,mBAAmB;MACnB,iBAAiB;IACnB;;IAEA;MACE,gDAAgD;MAChD,SAAS;IACX;;IAEA;MACE,iBAAiB;MACjB,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,0BAA0B;MAC1B,SAAS;MACT,mBAAmB;IACrB;EACF;;EAEA,wCAAwC;EACxC;IACE,yDAAyD;EAC3D;;EAEA;;;;;IAKE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;;;IAKE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uEAAuE;IACvE,YAAY;EACd;;EAEA;;;;IAIE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;;;;;IAOE;;;6BAGyB;EAC3B;;EAEA;;;;;;;IAOE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;IAME,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;;;;;IAKE,0BAA0B;EAC5B;;EAEA;;;IAGE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;MACE,QAAQ;IACV;;IAEA;;MAEE,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;;;MAGE,cAAc;IAChB;EACF;;EAEA,oDAAoD;EACpD;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,wGAAwG;IACxG,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE;MACE,qBAAqB;MACrB,oBAAoB;IACtB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF;;AAEF,uDAAuD;AACvD;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D;;0CAEwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;EACA;EACA,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB;EACzB;;;;kEAIgE;EAChE,4BAA4B;EAC5B,cAAc;AAChB","sourcesContent":["body {\n  overflow-x: hidden;\n  background-size: 650px 500px;\n  background-position: calc(100% - 2px) 100px;\n  background: #e6dddd;\n  color: #2b1d0f;\n}\n\n.category-heading {\n  display: none;\n}\n\n.category-strip {\n  display: none;\n}\n\n.mobile-top-bar {\n  display: none;\n  /* hide by default */\n}\n\n.whatsapp-float {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background: #25D366;\n  color: white;\n  font-size: 26px;\n  padding: 12px;\n  border-radius: 50%;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.whatsapp-float:hover {\n  transform: scale(1.1);\n}\n\n/* ===== TOP BAR ===== */\n.top-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  box-sizing: border-box;\n  height: 38px;\n  z-index: 10000;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #0b2747 0%, #154c85 100%);\n  padding: 0 28px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 6px 18px rgba(8, 28, 52, 0.24);\n}\n\n.top-icon {\n  margin-right: 6px;\n  vertical-align: middle;\n  font-size: 12px;\n}\n\n.top-bar a {\n  color: #e6efff;\n  text-decoration: none;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.1px;\n  transition: color 0.2s ease;\n}\n\n.top-bar a:hover {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.top-left,\n.top-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.top-left span,\n.top-right span {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  cursor: pointer;\n}\n\n.divider {\n  color: rgba(255, 255, 255, 0.35);\n}\n\n.header-item {\n  background-color: #007bff;\n  border-style: dashed;\n}\n\n.Navigation {\n  position: fixed;\n  top: 38px;\n  left: 0;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 9999;\n  border-bottom: 1px solid #d7e0ea;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(10px);\n}\n\nbody {\n  padding-top: 122px;\n}\n\n/* ===== SCROLL DOWN (COMPACT MODE) ===== */\n.Navigation.compact .search-container,\n.Navigation.compact .login,\n.Navigation.compact .header-right {\n  display: none !important;\n}\n\n/* Center menu when compact */\n.Navigation.compact .menu-items {\n  justify-content: center;\n  padding-left: 0;\n  width: 100%;\n}\n\n/* ===== SMOOTH TRANSITION ===== */\n.menu-search-compare {\n  transition: all 0.25s ease;\n}\n\n/* Optional: slight shrink effect */\n.Navigation.compact .menu-search-compare {\n  grid-template-columns: 1fr;\n  padding: 12px 28px;\n}\n\n.kebab-menu {\n  display: none;\n}\n\n.menu-search-compare {\n  padding: 14px 28px;\n  display: grid;\n  grid-template-columns: minmax(280px, 420px) 1fr auto auto;\n  align-items: center;\n  column-gap: 22px;\n  position: relative;\n  width: 100%;\n  max-width: 100vw;\n  box-sizing: border-box;\n  z-index: 20;\n  background: rgba(255, 255, 255, 0.96);\n}\n\n/* Menu Items*/\n.menu-items {\n  display: flex;\n  gap: 26px;\n  justify-content: center;\n  font-size: 16px;\n  margin: 0;\n  padding: 0;\n  z-index: 1000;\n  font-weight: 600;\n}\n\n.menu-items a {\n  text-decoration: none;\n  color: #132a45;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  padding-bottom: 4px;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.menu-items a:hover {\n  color: #0d5ea8;\n  border-bottom-color: #0d5ea8;\n  cursor: pointer;\n}\n\n.menu-items a:focus {\n  color: #0d5ea8;\n  outline: none;\n}\n\n.left-image {\n  width: 150px;\n  /* adjust size */\n  height: 150px;\n}\n\n.login {\n  color: #0f172a;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  border: 1px solid #cfd8e3;\n  border-radius: 10px;\n  padding: 10px 14px;\n  background: #ffffff;\n  transition: all 0.2s ease;\n}\n\n.login:hover {\n  color: #0d5ea8;\n  border-color: #0d5ea8;\n  cursor: pointer;\n}\n\n.login:focus {\n  color: #0d5ea8;\n  outline: none;\n}\n\n.compare-wishlist {\n  color: black;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.header-right i {\n  margin-right: 5px;\n}\n\n.header-right a,\n.header-right span {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  color: #0f172a;\n  font-size: 14px;\n  border: 1px solid #cfd8e3;\n  border-radius: 10px;\n  padding: 10px 12px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.header-badge {\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  min-width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  background: #e53935;\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n  padding: 0 4px;\n  border: 1.5px solid #ffffff;\n  box-sizing: border-box;\n}\n\n.header-right a,\n.mobile-cart-link,\n.mobile-bottom-nav .nav-item {\n  position: relative;\n}\n\n.header-right .header-badge {\n  top: -8px;\n  right: -8px;\n}\n\n.header-right a:hover,\n.header-right span:hover {\n  color: #0d5ea8;\n  border-color: #0d5ea8;\n}\n\n.compare-wishlist {\n  display: flex;\n  gap: 15px;\n}\n\n.search-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0;\n  gap: 12px;\n}\n\n.left-logo {\n  position: static;\n  width: 78px;\n  height: 78px;\n  object-fit: contain;\n  pointer-events: auto;\n}\n\n.Search {\n  width: 100%;\n  padding: 12px 45px 12px 14px;\n  border-radius: 10px;\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n  font-size: 15px;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n  margin-top: 0;\n}\n\n.Search:focus {\n  outline: none;\n  border-color: #0d5ea8;\n  box-shadow: 0 0 0 3px rgba(13, 94, 168, 0.12);\n}\n\n.search-button {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 17px;\n  color: #5f6b7b;\n}\n\n.search-button:hover {\n  color: #0d5ea8;\n}\n\n/* Browse Categories*/\n.browse-categories {\n  text-decoration: none !important;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: 5px;\n  margin-top: 70px;\n  padding: 10px 5px;\n  position: absolute;\n\n  border-radius: 5px;\n  text-decoration: none;\n  font-size: 18px;\n  font-weight: bold;\n  color: black;\n  cursor: pointer;\n  border-color: transparent;\n  transition: background-color 0.3s ease;\n}\n\n.browse-categories a {\n  text-decoration: none;\n  color: whitesmoke;\n  font-size: 16px;\n  font-weight: bold;\n  transition: color 0.3s ease;\n  font-family: Quicksand, sans-serif;\n}\n\n.browse-categories:hover {\n  background-color: #29a56c;\n  color: white;\n}\n\n.browse-categories i {\n  font-size: 20px;\n}\n\n.dropdown {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: white;\n  border-radius: 5px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 1;\n}\n\n.dropdown ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 10px 0;\n}\n\n.dropdown ul li a {\n  text-decoration: none;\n  color: black;\n  padding: 10px 20px;\n  display: block;\n  transition: background-color 0.3s ease;\n}\n\n.dropdown ul li a:hover {\n  background-color: lightgreen;\n  color: black;\n}\n\n.extra-categories {\n  display: none;\n}\n\n#toggle-more {\n  font-weight: bold;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n#toggle-more:hover {\n  color: lightgreen;\n  color: black;\n}\n\n.discount-text {\n  position: absolute;\n  top: 50%;\n  left: 30px;\n  transform: translateY(-110%);\n  background: transparent;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 5px;\n  text-align: left;\n  width: auto;\n}\n\n.original-price {\n  text-decoration: line-through;\n  color: red;\n  font-size: 20px;\n  gap: 10px;\n}\n\n.discounted-price {\n  font-size: 22px;\n  font-weight: bold;\n  color: yellow;\n  margin-left: 10px;\n}\n\n.discount-text h2 {\n  font-size: 50px;\n  font-weight: bold;\n  color: #ffcc00;\n}\n\n.Banner-container {\n  --hero-blue: #0b2d5c;\n  --hero-accent: #f2a61f;\n  border-radius: 22px;\n  margin: 2rem auto 0;\n  position: relative;\n  width: min(96%, 1240px);\n  height: clamp(360px, 62vh, 620px);\n  overflow: hidden;\n  background: radial-gradient(circle at top right, #f6faff 0%, #edf3fc 42%, #e6eef9 100%);\n  box-shadow: 0 18px 45px rgba(9, 30, 66, 0.2);\n}\n\n/* Slideshow content */\n.slideshow-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.slides {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  transition: transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);\n  will-change: transform;\n}\n\n.slide {\n  min-width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  position: relative;\n  isolation: isolate;\n}\n\n.slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: transparent;\n  transform: scale(1.02);\n}\n\n.slide::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(100deg,\n      rgba(8, 18, 36, 0.6) 8%,\n      rgba(8, 18, 36, 0.2) 46%,\n      rgba(8, 18, 36, 0) 76%);\n  pointer-events: none;\n}\n\n/* Arrow buttons for manual navigation */\n.prev,\n.next {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.92);\n  color: #173a69;\n  height: 44px;\n  width: 44px;\n  cursor: pointer;\n  border: 1px solid rgba(23, 58, 105, 0.2);\n  border-radius: 50%;\n  font-size: 20px;\n  transition: all 0.25s ease;\n  box-shadow: 0 8px 18px rgba(10, 31, 57, 0.16);\n  z-index: 2;\n}\n\n.prev {\n  left: 20px;\n}\n\n.next {\n  right: 20px;\n}\n\n.mobile-bottom-nav {\n  display: none;\n}\n\n/* Add hover effect for better visibility */\n.prev:hover,\n.next:hover {\n  background: var(--hero-blue);\n  color: #ffffff;\n  border-color: transparent;\n}\n\n.banner-info {\n  position: absolute;\n  left: clamp(16px, 3vw, 32px);\n  bottom: clamp(16px, 3.3vw, 34px);\n  z-index: 2;\n  color: #ffffff;\n  padding: 14px 16px;\n  border-radius: 14px;\n  background: rgba(5, 14, 28, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  backdrop-filter: blur(8px);\n  max-width: min(80%, 520px);\n}\n\n.banner-info h3 {\n  margin: 0 0 8px;\n  font-size: clamp(1.05rem, 2vw, 1.6rem);\n  line-height: 1.2;\n  letter-spacing: 0.2px;\n}\n\n.banner-info p {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.banner-info .cut-price {\n  text-decoration: line-through;\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 0.95rem;\n}\n\n.banner-info .discounted-price {\n  color: #ffce6b;\n  font-weight: 700;\n  font-size: clamp(1rem, 1.8vw, 1.2rem);\n}\n\n.banner-dots {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 14px;\n  display: flex;\n  gap: 8px;\n  z-index: 3;\n}\n\n.banner-dot {\n  width: 8px;\n  height: 8px;\n  border: none;\n  border-radius: 99px;\n  background: rgba(255, 255, 255, 0.52);\n  padding: 0;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\n.banner-dot.active {\n  width: 24px;\n  background: linear-gradient(90deg, var(--hero-blue), var(--hero-accent));\n}\n\n@media screen and (max-width: 768px) {\n  .Banner-container {\n    width: 94%;\n    margin-top: 1.2rem;\n    height: clamp(240px, 46vw, 320px);\n    border-radius: 14px;\n  }\n\n  .prev,\n  .next {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n    top: calc(50% - 8px);\n  }\n\n  .prev {\n    left: 10px;\n  }\n\n  .next {\n    right: 10px;\n  }\n\n  .banner-info {\n    left: 10px;\n    right: 10px;\n    bottom: 10px;\n    max-width: none;\n    padding: 10px 12px;\n  }\n\n  .banner-info h3 {\n    margin-bottom: 6px;\n    font-size: 0.95rem;\n  }\n\n  .banner-info .cut-price,\n  .banner-info .discounted-price {\n    font-size: 0.88rem;\n  }\n\n  .banner-dots {\n    bottom: 6px;\n    gap: 6px;\n  }\n}\n\n/* Featured Categories and product container*/\n.product-container {\n  text-align: center;\n  color: black;\n  margin-top: 20px;\n  justify-content: center;\n  gap: 10px;\n}\n\n.featured-categories {\n  margin-top: 20px;\n  justify-content: center;\n}\n\n.product-box-container {\n  list-style-type: none;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: left;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.product-box-container li {\n  width: 150px;\n  height: 150px;\n}\n\n.product-box-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n#productSlider {\n  display: flex;\n  margin-left: 30px;\n  gap: 20px;\n  transition: transform 0.5s ease;\n}\n\n.product-item img {\n  width: 100%;\n  max-width: 300px;\n}\n\n.slider-wrapper {\n  position: relative;\n  overflow: hidden;\n}\n\n.prev-btn,\n.next-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #068ce5;\n  color: #fff;\n  border: none;\n  font-size: 24px;\n  padding: 10px;\n  cursor: pointer;\n  border-radius: 5rem;\n  height: 3rem;\n  width: 3rem;\n  z-index: 10;\n}\n\n.prev-btn {\n  left: 10px;\n}\n\n.next-btn {\n  right: 10px;\n}\n\n/* Ads container styling*/\n.product-item {\n  width: 100%;\n\n  padding-left: 50px;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  border-radius: 10px;\n  padding: 10px;\n  box-sizing: border-box;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  justify-content: flex-start;\n  margin-top: 50px;\n}\n\n.product-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 90px;\n  background-color: whitesmoke;\n  border-radius: 10px;\n\n  /* gap: 10px; */\n}\n\n/* Add to Cart Button */\n.add-to-cart-btn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 10px;\n  font-size: 14px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  width: 100%;\n  text-align: center;\n}\n\n/* Image styling */\n.product-item img {\n  width: 100%;\n  max-width: 300px;\n  height: 130px;\n  background-color: #ffffff;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.product-item img:hover {\n  transform: translateY(-10px);\n}\n\n.product-name {\n  font-size: 1.2rem;\n  margin-bottom: 10px;\n}\n\n.product-price {\n  font-size: 1rem;\n  color: #333;\n  margin-top: 10px;\n}\n\n/* Each individual box */\n.product-box {\n  background-color: #ffffff;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 30%;\n  text-align: center;\n  transition: transform 0.3s ease;\n  gap: 10px;\n  text-align: center;\n  margin: 20px;\n  border: 1px solid#ddd;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 350px;\n}\n\n/* Hover effect for individual boxes */\n.product-box:hover {\n  transform: translateY(-10px);\n}\n\nh1 {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.shop-btn {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  border-radius: 10px;\n}\n\n.shop-btn:hover {\n  background-color: lightgreen;\n}\n\n.shop-btn:active {\n  background-color: green;\n}\n\n.product-box img {\n  width: 80%;\n  height: auto;\n  max-width: 300px;\n  margin: 20px 0;\n}\n\n/* Popular-Product styling */\n.popular-product-heading {\n  color: black;\n  margin-left: 10px;\n  margin-top: 10px;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.column {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 10px;\n  gap: 15px;\n}\n\n.product-card {\n  color: black;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  text-align: center;\n  transition:\n    transform 0.3s ease-in-out,\n    box-shadow 0.3s ease-in-out;\n\n  width: 180px;\n  position: relative;\n  background-color: #fff;\n}\n\n.product-card:hover {\n  transform: scale(1.05);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);\n}\n\n.product-image {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.product-name {\n  font-size: 16px;\n  font-weight: bold;\n  margin: 10px 0;\n  cursor: pointer;\n}\n\n.product-name:hover {\n  color: green;\n}\n\n.product-price {\n  font-size: 14px;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.product-actions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  position: absolute;\n  bottom: 10px;\n  width: 100%;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.product-card:hover .product-actions {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.product-actions button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  transition:\n    transform 0.3s ease-in-out,\n    color 0.3s ease-in-out;\n}\n\n.product-actions button:hover {\n  transform: scale(1.2);\n  color: #555;\n}\n\n.cart-btn i {\n  color: #068ce5;\n}\n\n.view-btn i {\n  color: #2980b9;\n}\n\n.wishlist-btn i {\n  color: #e74c3c;\n}\n\n/* Optional: Add subtle shadow on hover for buttons */\n.product-actions button:hover i {\n  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.popular-product-heading {\n  color: black;\n  margin-left: 10px;\n  margin-top: 10px;\n}\n\n.product-card:hover {\n  transform: scale(1.05);\n}\n\n.product-image {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n}\n\n.product-name {\n  font-size: 16px;\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.product-name:hover {\n  color: green;\n  cursor: pointer;\n}\n\n.product-price {\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.product-actions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  position: relative;\n}\n\n.product-actions button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  transition:\n    opacity 0.3s ease-in-out,\n    transform 0.3s ease-in-out;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(10px);\n  color: #068ce5;\n}\n\n.product-actions:hover button {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(0);\n}\n\n.cart-btn:hover {\n  color: gray;\n}\n\n.wishlist-btn i {\n  color: #068ce5;\n}\n\n.view-btn i {\n  color: #068ce5;\n}\n\n.column {\n  display: flex;\n  padding: 10px;\n  gap: 10px;\n  padding-left: 20px;\n}\n\n.heading-daily {\n  color: black;\n  margin-left: 10px;\n  padding: 10px;\n}\n\n.ads-product-container {\n  display: flex;\n  gap: 70px;\n  justify-content: center;\n}\n\n.product-box-ads {\n  flex: 1;\n  max-width: 300px;\n  background-color: whitesmoke;\n  border-radius: 10px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  height: 400px;\n  box-sizing: border-box;\n  text-align: center;\n  color: black;\n  transition: transform 0.3s ease;\n}\n\n.product-box-ads:hover {\n  transform: translateY(-10px);\n}\n\n.product-box-ads img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.shop-now-btn {\n  padding: 10px 20px;\n  border: none;\n  background-color: #068ce5;\n  color: white;\n  font-weight: bold;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.shop-now-btn:hover {\n  transform: scale(1.05);\n}\n\n/*best sell container*/\n.best-sell {\n  color: black;\n  display: flex;\n  gap: 10px;\n}\n\n.banner-text {\n  color: black;\n}\n\n.content-wrapper {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  width: 100%;\n  padding: 20px;\n}\n\n/* Fixed container */\n.fixed-container {\n  width: 300px;\n  padding: 20px 30px;\n  border: 1px solid #ddd;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n  background: white;\n  flex-shrink: 0;\n  border-radius: 10px;\n  transition: transform 0.5s ease-in-out;\n  margin-left: 20px;\n}\n\n.fixed-container img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 8px;\n  display: block;\n}\n\n.fixed-container:hover {\n  transform: scale(1.05);\n  scroll-behavior: smooth;\n}\n\n.carousel-container {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.carousel {\n  display: flex;\n  gap: 2px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 10px;\n}\n\n/* Individual Carousel Item */\n.carousel-item {\n  border-radius: 10px;\n  position: relative;\n  min-width: 200px;\n  max-width: 200px;\n  text-align: center;\n  margin-right: 10px;\n  height: 350px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  padding: 20px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n  transition: transform 0.5s ease-in-out;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.carousel::-webkit-scrollbar {\n  display: none;\n}\n\n.carousel-item:hover {\n  transform: scale(1.05);\n  border: 2px solid #1d0170;\n}\n\n.carousel-item img {\n  width: 100px;\n  height: 100px;\n  border-radius: 10px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n  transition: transform 0.5s ease-in-out;\n}\n\n.carousel-item h3 {\n  margin: 10px 0;\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  max-height: 40px;\n  word-break: break-word;\n  padding: 0 5px;\n}\n\n/* Icons Container */\n.product-icons {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 5px;\n}\n\n.product-icons button {\n  margin-bottom: 5px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  transition:\n    opacity 0.3s ease-in-out,\n    transform 0.3s ease-in-out;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(10px);\n}\n\n.product-icons:hover button {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(0);\n}\n\n.product-icons button:hover {\n  color: #1d0170;\n}\n\n.wishlist-btn i {\n  color: #068ce5;\n}\n\n.compare-btn i {\n  color: grey;\n}\n\n.preview-btn i {\n  color: #068ce5;\n}\n\n.add-to-cart-btn:hover {\n  background-color: #1d0170;\n}\n\n/* Carousel Arrows */\n.carousel-container {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.arrow-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #068ce5;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  font-size: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 10;\n  transition:\n    background-color 0.3s ease,\n    transform 0.3s ease;\n}\n\n.arrow-btn:hover {\n  background-color: #1d0170;\n  transform: scale(1.1);\n}\n\n.arrow-btn:first-of-type {\n  left: 10px;\n}\n\n.arrow-btn:last-of-type {\n  right: 10px;\n}\n\n/*Deals of the day*/\n.deals-of-the-day {\n  color: black;\n  margin-left: 10px;\n  margin-top: 40px;\n}\n\n.carousel-item {\n  position: relative;\n  text-align: center;\n  padding: 10px;\n  background: #fff;\n  border-radius: 10px;\n  margin: 0 10px;\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.carousel-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n/* Hover icons container */\n.product-icons {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin: 10px 0;\n}\n\n.product-icons button {\n  border: none;\n  background: #f0f0f0;\n  padding: 8px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.product-icons button:hover {\n  background: #ddd;\n}\n\n/* Text Add to Cart button below hover icons */\n.text-add-to-cart-btn {\n  display: inline-block;\n  margin-top: 5px;\n  padding: 6px 12px;\n  background-color: #068ce5;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.text-add-to-cart-btn:hover {\n  background-color: #1d0170;\n}\n\n.deals-container {\n  display: flex;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  width: 80%;\n  margin-bottom: 20px;\n  padding-left: 5px;\n}\n\n/*Deal of day */\n.deals-container {\n  display: flex;\n  gap: 20px;\n  margin: 20px 40px;\n}\n\n.deal-box:hover {\n  transform: scale(1.05);\n  scroll-behavior: smooth;\n}\n\n.deal-box {\n  flex: 1;\n  border: 1px solid #ddd;\n  padding: 15px;\n  text-align: center;\n  border-radius: 10px;\n  background: #fff;\n  transition: transform 0.5s ease-in-out;\n  color: black;\n  justify-content: center;\n}\n\n\n\n\n\n.deal-image {\n  display: block;\n  margin: 0 auto;\n  height: 200px;\n  object-fit: cover;\n}\n.countdown {\n  display: flex;\n  justify-content: space-around;\n  margin: 10px 0;\n  color: black;\n}\n\n.countdown div span {\n  font-weight: bold;\n  font-size: 18px;\n}\n\n.deal-price {\n  font-weight: bold;\n  margin: 10px 0;\n  color: black;\n}\n\n.deal-cart-btn {\n  padding: 8px 15px;\n  border: none;\n  background: #068ce5;\n  color: white;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.selling-product {\n  display: flex;\n  gap: 20px;\n  margin-top: 40px;\n}\n\n.selling-column {\n  flex: 1;\n}\n\n.small-product {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n  align-items: center;\n}\n\n.small-product img {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n}\n\n/* Container for all 4 categories in a row */\n.selling-product {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  flex-wrap: wrap;\n}\n\n/* Each category box */\n.product-category {\n  flex: 1;\n  min-width: 250px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 15px;\n  background-color: #fafafa;\n  transition: transform 0.5s ease-in-out;\n}\n\n.product-category:hover {\n  transform: scale(1.05);\n  scroll-behavior: smooth;\n}\n\n/* Category title */\n.category-title {\n  font-size: 20px;\n  margin-bottom: 15px;\n  color: #333;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 5px;\n}\n\n/* Container for small product cards inside a category */\n.small-product-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Single small product card */\n.small-product-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 8px;\n  transition: transform 0.2s;\n}\n\n.small-product-card:hover {\n  transform: translateY(-2px);\n}\n\n/* Product image */\n.small-product-image {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n/* Product name */\n.small-product-name {\n  font-size: 14px;\n  font-weight: 600;\n  flex-basis: 70px;\n  margin: 0;\n  color: #333;\n}\n\n/* Product price */\n.small-product-price {\n  font-size: 13px;\n  font-weight: 500;\n  color: #e74c3c;\n  flex-basis: 60px;\n  margin: 0;\n}\n\n/* Product description */\n.small-product-desc {\n  font-size: 12px;\n  color: #555;\n  flex: 1;\n  margin: 0;\n}\n\n/*banner-below-container*/\n.Banner-container-below {\n  margin: 20px auto;\n  border-radius: 10px;\n  position: relative;\n  width: 95%;\n  height: 450px;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n\n}\n\n.ads-slider img{\nheight: auto;\nwidth: 100%;\n}\n/*Tags */\n.tags {\n  display: flex;\n  gap: 50px;\n  color: black;\n  margin-top: 20px;\n  margin-left: 20px;\n  margin-bottom: 30px;\n}\n\n.tag {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.tag-content {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  transition: transform 0.5s ease-in-out;\n}\n\n.tag-content:hover {\n  transform: scale(1.05);\n  scroll-behavior: smooth;\n}\n\n.tag-content span {\n  margin-top: 40px;\n  margin-left: 30px;\n  font-weight: bold;\n  display: flex;\n  gap: 5px;\n}\n\n.tag-content p {\n  margin: 5px 0 0;\n  font-size: 14px;\n  font-weight: normal;\n  color: black;\n}\n\n.tag i {\n  position: absolute;\n}\n\n/* Footer */\n.blue-text {\n  color: #3391ff;\n}\n\n.yellow-text {\n  color: #f3bd29;\n}\n\n.footer {\n  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);\n  --footer-text: #e8f0f8;\n  --footer-muted: #c7d5e3;\n  --footer-border: rgba(255, 255, 255, 0.14);\n  --footer-highlight: #f3bd29;\n  margin: 70px 0 -12px;\n  padding: 40px clamp(18px, 3vw, 42px) 18px;\n  color: var(--footer-text);\n  background: var(--footer-bg);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.footer-main {\n  width: min(1240px, 100%);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);\n  gap: clamp(18px, 3vw, 36px);\n  align-items: flex-start;\n}\n\n.footer-brand-block {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.footer-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n.footer-brand img {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n}\n\n.footer-brand h2 {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: clamp(22px, 2.1vw, 28px);\n  letter-spacing: 0.02em;\n}\n\n.footer-description {\n  margin: 0;\n  max-width: 34ch;\n  color: var(--footer-muted);\n  line-height: 1.65;\n  font-size: 14px;\n}\n\n.footer-contact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-contact-list a {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--footer-text);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n}\n\n.footer-contact-list a:hover {\n  color: var(--footer-highlight);\n}\n\n.footer-contact-list a svg {\n  color: var(--footer-highlight);\n  flex-shrink: 0;\n}\n\n.footer-link-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-link-group h3,\n.footer-social-block h3 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: #ffffff;\n  letter-spacing: 0.01em;\n}\n\n.footer-link-group a {\n  color: var(--footer-muted);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n  transition: color 0.2s ease;\n}\n\n.footer-link-group a:hover {\n  color: #ffffff;\n}\n\n.footer-social-block {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-social-block p {\n  margin: 0;\n  color: var(--footer-muted);\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.footer-social-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n.footer-social-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 42px;\n  border: 1px solid var(--footer-border);\n  border-radius: 999px;\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.06);\n  transition:\n    transform 0.2s ease,\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.footer-social-item:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.26);\n}\n\n.footer-bottom {\n  width: min(1240px, 100%);\n  margin: 28px auto 0;\n  padding-top: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.16);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  color: var(--footer-muted);\n  font-size: 13px;\n}\n\n.footer-bottom-links {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.footer-bottom-links a {\n  color: var(--footer-muted);\n  text-decoration: none;\n}\n\n.footer-bottom-links a:hover {\n  color: #ffffff;\n}\n\n@media screen and (max-width: 1080px) {\n  .footer-main {\n    grid-template-columns: repeat(2, minmax(220px, 1fr));\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .footer {\n    margin-top: 48px;\n    padding: 30px 16px 90px;\n  }\n\n  .footer-main {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .footer-social-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    font-size: 12px;\n  }\n\n  .footer-bottom-links {\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}\n\n/* Mobile Bottom Navigation */\n\n\n/* ===== Laptop View Only (1024px – 1440px) ===== */\n@media screen and (min-width: 1024px) and (max-width: 1440px) {\n  /* .menu-items {\n    gap: 60px;\n    padding-left: 220px;\n    font-size: 17px;\n  } */\n\n  /* .search-container {\n    width: 45%;\n    margin-left: 25%;\n  } */\n\n  .Banner-container {\n    max-width: 90%;\n    height: 420px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .product-box {\n    width: 28%;\n    height: 360px;\n  }\n\n  .Ads-product-container {\n    justify-content: center;\n    gap: 20px;\n  }\n\n  .carousel-container {\n    max-width: 1000px;\n    height: 380px;\n  }\n\n  .carousel-item {\n    min-width: 220px;\n    max-width: 220px;\n  }\n\n  .deals-container {\n    width: 85%;\n  }\n\n  .selling-product {\n    gap: 30px;\n  }\n\n  .tags {\n    gap: 70px;\n  }\n}\n\n.info-icon {\n  margin-right: 8px;\n  font-size: 16px;\n}\n\n.home {\n  color: #4caf50;\n}\n\n.email {\n  color: #ea4335;\n}\n\n.phone {\n  color: #1877f2;\n}\n\n@media (max-width: 1366px) and (min-width: 769px) {\n  .top-bar {\n    padding: 0 16px;\n  }\n\n  .top-left,\n  .top-right {\n    gap: 8px;\n  }\n\n  .menu-search-compare {\n    grid-template-columns: minmax(240px, 340px) 1fr auto auto;\n    column-gap: 12px;\n    padding: 12px 16px;\n  }\n\n  .menu-items {\n    gap: 16px;\n  }\n\n  .menu-items a {\n    font-size: 15px;\n  }\n\n  .login,\n  .header-right a,\n  .header-right span {\n    padding: 9px 10px;\n  }\n}\n\n@media (max-width: 1180px) and (min-width: 769px) {\n  .menu-search-compare {\n    grid-template-columns: minmax(220px, 300px) 1fr auto;\n  }\n\n  .login {\n    display: none;\n  }\n\n  .header-right {\n    gap: 8px;\n  }\n\n  .header-right a,\n  .header-right span {\n    font-size: 13px;\n    padding: 8px 10px;\n  }\n\n  .menu-items {\n    gap: 12px;\n  }\n\n  .menu-items a {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 1024px) and (min-width: 769px) {\n  .top-bar {\n    justify-content: flex-end;\n    padding: 0 10px;\n  }\n\n  .top-left {\n    display: none;\n  }\n\n  .top-right {\n    width: 100%;\n    justify-content: flex-end;\n    gap: 6px;\n  }\n\n  .top-right > a:not(:last-of-type),\n  .top-right > .divider:not(:last-child) {\n    display: none;\n  }\n\n  .top-right a {\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  .menu-search-compare {\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"search actions\"\n      \"menu menu\";\n    row-gap: 10px;\n    column-gap: 10px;\n    padding: 10px 12px;\n  }\n\n  .search-container {\n    grid-area: search;\n    min-width: 0;\n    gap: 8px;\n  }\n\n  .menu-items {\n    grid-area: menu;\n    justify-content: flex-start;\n    overflow-x: auto;\n    white-space: nowrap;\n    gap: 14px;\n    padding-bottom: 3px;\n  }\n\n  .menu-items::-webkit-scrollbar {\n    display: none;\n  }\n\n  .header-right {\n    grid-area: actions;\n    justify-content: flex-end;\n    gap: 6px;\n  }\n\n  .login {\n    display: none;\n  }\n\n  .left-logo {\n    width: 58px;\n    height: 58px;\n  }\n\n  .Search {\n    padding: 10px 38px 10px 12px;\n    font-size: 14px;\n  }\n\n  .header-right a,\n  .header-right span {\n    width: 38px;\n    height: 36px;\n    padding: 0;\n    font-size: 0;\n    justify-content: center;\n  }\n\n  .fancy-icon {\n    font-size: 15px;\n    margin: 0;\n  }\n}\n\n@media (max-width: 768px) {\n\n  /* Hide desktop nav, show mobile bottom nav */\n  .Navigation,\n  .top-bar {\n    display: none;\n  }\n\n  html,\n  body {\n    max-width: 100%;\n    overflow-x: hidden;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .kebab-menu {\n    display: block;\n    font-size: 30px;\n    cursor: pointer;\n    position: fixed;\n    top: 15px;\n    right: 20px;\n    z-index: 10001;\n    color: #068ce5;\n\n  }\n\n  .mobile-top-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #ffffff;\n    padding: 10px 8px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 10002;\n    gap: 6px;\n    border-bottom: 1px solid #dbe4ee;\n    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);\n  }\n\n  .mobile-logo {\n    height: 38px;\n    flex-shrink: 0;\n  }\n\n  .mobile-quick-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n  }\n\n  .mobile-phone-link\n{\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    border: 1px solid #d5e1ee;\n    border-radius: 8px;\n    background: #f7fbff;\n    color: #16314d;\n    min-height: 34px;\n  }\n  .deal-image{\n    width: 100%;\n    height: 100%;\n  }\n\n  .mobile-phone-link {\n    gap: 5px;\n    padding: 0 8px;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n  }\n\n  .mobile-cart-link {\n    width: 34px;\n  }\n\n  .mobile-cart-link .header-badge,\n  .mobile-bottom-nav .header-badge {\n    top: -7px;\n    right: -9px;\n    border-color: #ffffff;\n  }\n\n  .mobile-search-wrapper {\n    flex: 1;\n    display: flex;\n    gap: 5px;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .mobile-search {\n    flex: 1;\n    padding: 8px 10px;\n    border-radius: 8px;\n    border: 1px solid #cfdae6;\n    background: #f7f9fc;\n    font-size: 14px;\n  }\n\n  .mobile-search-btn {\n    background: #0d5ea8;\n    color: #ffffff;\n    border: 1px solid #0d5ea8;\n    padding: 8px 10px;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .mobile-menu-btn {\n    font-size: 26px;\n    color: #16314d;\n    cursor: pointer;\n    flex-shrink: 0;\n    margin-right: 2px;\n    font-weight: bold;\n  }\n\n  @media (max-width: 400px) {\n    .mobile-phone-link span {\n      display: none;\n    }\n\n    .mobile-phone-link {\n      width: 34px;\n      padding: 0;\n    }\n\n    .mobile-logo {\n      height: 34px;\n    }\n  }\n\n  .mobile-drawer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 82%;\n    height: 100%;\n    background: #f8fafd;\n    z-index: 10003;\n    overflow-y: auto;\n    padding: 16px;\n    padding-top: 74px;\n    padding-bottom: 3rem;\n    transform: translateX(100%);\n    transition: transform 0.25s ease-in-out;\n    box-shadow: -12px 0 30px rgba(15, 23, 42, 0.16);\n  }\n\n  .mobile-drawer.open {\n    transform: translateX(0);\n  }\n\n  body {\n    padding-top: 64px;\n    padding-bottom: 70px;\n  }\n\n  /* Login Card */\n  .login-card {\n    background: linear-gradient(135deg, #0d5ea8 0%, #1e73bf 100%);\n    color: white;\n    border-radius: 12px;\n    padding: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    margin-left: 0;\n  }\n\n  .login-card h3 {\n    margin: 0;\n    font-size: 18px;\n  }\n\n  .login-card p {\n    margin: 4px 0 0;\n    font-size: 14px;\n  }\n\n  .login-btn {\n    background: #0f172a;\n    color: white;\n    padding: 8px 16px;\n    border-radius: 8px;\n    text-decoration: none;\n    font-weight: bold;\n  }\n\n  /* Sections */\n  .menu-section {\n    background: white;\n    border-radius: 12px;\n    margin-bottom: 15px;\n    padding: 10px 0;\n    border: 1px solid #e4eaf2;\n  }\n\n  .menu-section h4 {\n    margin: 0;\n    padding: 10px 15px;\n    font-size: 14px;\n    color: #666;\n  }\n\n  /* Items */\n  .menu-item {\n    display: flex;\n    justify-content: space-between;\n    padding: 12px 15px;\n    text-decoration: none;\n    color: #333;\n    border-top: 1px solid #eee;\n    font-size: 15px;\n  }\n\n  .menu-item:first-of-type {\n    border-top: none;\n  }\n\n  .menu-item:hover {\n    background: #f3f8ff;\n  }\n\n  .mobile-bottom-nav {\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background: #ffffff;\n    border-top: 1px solid #d9e2ec;\n    justify-content: space-around;\n    align-items: center;\n    padding: 10px 5px;\n    z-index: 9999;\n    box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.08);\n  }\n\n  .mobile-bottom-nav .nav-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 12px;\n    color: #20354d;\n    text-decoration: none;\n    gap: 2px;\n  }\n\n  .mobile-bottom-nav .nav-item svg {\n    font-size: 18px;\n    margin-bottom: 2px;\n  }\n\n  body {\n    padding-bottom: 70px;\n  }\n\n  /* Search full width */\n  .search-container {\n    width: 95%;\n    margin: 10px auto;\n  }\n\n  .Banner-container {\n    height: 250px;\n    margin: 10px auto;\n    width: 95%;\n  }\n\n  /* Featured categories slider → horizontal scroll */\n  .product-box-container {\n    display: flex;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    gap: 10px;\n    padding: 20px;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .product-item {\n    min-width: 120px;\n    flex-shrink: 0;\n    scroll-snap-align: start;\n    cursor: pointer;\n  }\n\n  /* Ads → stack nicely */\n  .ads-product-container {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    align-items: center;\n  }\n\n  .product-box-ads {\n    width: 90%;\n    height: auto;\n    cursor: pointer;\n  }\n\n  /* Popular products → grid (2 per row) */\n  .column {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 35px;\n  }\n\n  .popular-product-heading h2 {\n    margin-left: 10px;\n    padding: 10px;\n  }\n\n  .product-card {\n    width: 100%;\n    cursor: pointer;\n  }\n\n  /* Best sell section */\n  .best-sell {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  /* Fixed container for padding */\n  .fixed-container {\n    width: 90%;\n    margin: auto;\n  }\n\n  /* Deals → stack vertically */\n  .deals-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin: 10px 0;\n    gap: 15px;\n  }\n\n  /* Selling categories stacked */\n  .selling-product {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .tags {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .product-box-ads {\n    display: none;\n  }\n\n  .fixed-container {\n    display: none;\n  }\n\n  .whatsapp-float {\n    margin-bottom: 50px;\n    margin-right: -10px;\n  }\n\n  .category-heading {\n    color: black;\n    margin-left: 5px;\n    display: block;\n  }\n\n  .category-strip {\n    display: flex;\n    overflow-x: auto;\n    gap: 12px;\n    padding: 10px;\n  }\n\n  .category-box {\n    flex: 0 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 80px;\n    height: 80px;\n    padding: 10px;\n    background: #f8f8f8;\n    border-radius: 12px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n    text-align: center;\n    color: black;\n  }\n\n   .Banner-container-below {\n    margin-top: 24px;\n    border-radius: 18px;\n    border: 1px solid var(--border-soft);\n    box-shadow: var(--shadow-soft);\n    height: auto;\n  }\n\n.Banner-container-below img{\n    height: 100%;\n    width: 100%;\n  }\n\n  .category-box p {\n    font-size: 12px;\n    margin-top: 5px;\n    color: #333;\n  }\n\n  .category-box:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  .category-box-link {\n    text-decoration: none;\n  }\n}\n\n  /* ===== Homepage Professional Polish ===== */\n  :root {\n    --home-bg: #f4f7fb;\n    --surface: #ffffff;\n    --surface-soft: #f8fbff;\n    --text-strong: #11253d;\n    --text-muted: #607086;\n    --border-soft: #deebf7;\n    --brand: #0f62ad;\n    --brand-dark: #0a4f8f;\n    --accent: #f5b93f;\n    --shadow-soft: 0 10px 26px rgba(17, 37, 61, 0.08);\n    --shadow-raise: 0 18px 36px rgba(17, 37, 61, 0.14);\n  }\n\n  body {\n    background: radial-gradient(circle at 20% 0%, #ffffff 0%, #f1f6fd 38%, #edf3fb 100%);\n    color: var(--text-strong);\n  }\n\n  .featured-categories,\n  .popular-product-heading,\n  .heading-daily,\n  .deals-of-the-day,\n  .category-heading {\n    width: min(96%, 1240px);\n    margin: 36px auto 12px;\n    padding: 0;\n    color: var(--text-strong);\n    font-size: clamp(1.2rem, 1.8vw, 1.8rem);\n    font-weight: 750;\n    letter-spacing: 0.2px;\n  }\n\n  .product-container,\n  .ads-product-container,\n  .column,\n  .best-sell,\n  .deals-container,\n  .selling-product,\n  .tags,\n  .Banner-container-below,\n  .category-strip {\n    width: min(96%, 1240px);\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .product-container {\n    margin-top: 8px;\n  }\n\n  .slider-wrapper {\n    background: var(--surface);\n    border: 1px solid var(--border-soft);\n    border-radius: 18px;\n    box-shadow: var(--shadow-soft);\n    padding: 16px 12px;\n  }\n\n  .product-item {\n    margin-top: 0;\n    padding: 0;\n  }\n\n  .product-info {\n    width: 100%;\n    margin-bottom: 0;\n    background: transparent;\n    border-radius: 0;\n  }\n\n  #productSlider {\n    margin-left: 0;\n    gap: 14px;\n  }\n\n  .product-item img {\n    border-radius: 12px;\n    background: #ffffff;\n  }\n\n  .ads-product-container {\n    gap: 20px;\n    margin-top: 20px;\n  }\n\n  .product-box-ads,\n  .product-card,\n  .fixed-container,\n  .carousel-item,\n  .deal-box,\n  .product-category,\n  .small-product-card,\n  .tag {\n    border: 1px solid var(--border-soft);\n    box-shadow: var(--shadow-soft);\n    border-radius: 16px;\n    background: var(--surface);\n  }\n\n  .product-box-ads:hover,\n  .product-card:hover,\n  .fixed-container:hover,\n  .carousel-item:hover,\n  .deal-box:hover,\n  .product-category:hover,\n  .small-product-card:hover {\n    transform: translateY(-6px);\n    box-shadow: var(--shadow-raise);\n  }\n\n  .product-box-ads {\n    max-width: 350px;\n    height: 420px;\n  }\n\n  .product-box-ads img {\n    border-radius: 12px;\n  }\n\n  .column {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n    gap: 2rem;\n    padding: 6px 0;\n\n  }\n\n  .product-card {\n    width: 100%;\n    min-height: 280px;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n  .product-name,\n  .small-product-name,\n  .category-title {\n    color: var(--text-strong);\n  }\n\n  .product-price,\n  .small-product-price,\n  .deal-price {\n    color: #0f4c86;\n    font-weight: 700;\n  }\n\n  .product-actions {\n    margin-top: auto;\n    padding-top: 10px;\n  }\n\n  .product-actions button {\n    background: var(--surface-soft);\n    border: 1px solid var(--border-soft);\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n  }\n\n  .product-actions button:hover {\n    background: #edf4ff;\n    border-color: #bfd6ee;\n  }\n\n  .best-sell {\n    align-items: stretch;\n    gap: 18px;\n  }\n\n  .fixed-container {\n    margin-left: 0;\n    width: 330px;\n  }\n\n  .fixed-container h3,\n  .carousel-item h3,\n  .deal-box h3 {\n    margin: 8px 0 6px;\n    color: var(--text-strong);\n  }\n\n  .carousel {\n    gap: 12px;\n    padding: 8px 10px;\n  }\n\n  .carousel-item {\n    min-width: 220px;\n    max-width: 220px;\n    height: 360px;\n  }\n\n  .arrow-btn,\n  .prev-btn,\n  .next-btn {\n    background: rgba(255, 255, 255, 0.95);\n    color: var(--brand-dark);\n    border: 1px solid #bdd5ed;\n    box-shadow: 0 8px 18px rgba(17, 37, 61, 0.12);\n  }\n\n  .arrow-btn:hover,\n  .prev-btn:hover,\n  .next-btn:hover {\n    background: var(--brand);\n    color: #ffffff;\n    border-color: transparent;\n  }\n\n  .deals-container {\n    margin-top: 12px;\n    margin-bottom: 0;\n  }\n\n  .deal-box {\n    padding: 16px;\n  }\n\n  .deal-image {\n    border-radius: 12px;\n  }\n\n  .countdown {\n    background: var(--surface-soft);\n    border: 1px solid var(--border-soft);\n    border-radius: 12px;\n    padding: 8px;\n  }\n\n  .countdown div span {\n    color: var(--brand-dark);\n  }\n\n  .selling-product {\n    gap: 14px;\n    padding: 0;\n    margin-top: 24px;\n  }\n\n  .product-category {\n    background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);\n  }\n\n  .category-title {\n    border-bottom: 1px solid var(--border-soft);\n  }\n\n  .small-product-card {\n    gap: 12px;\n    padding: 10px;\n  }\n\n  .small-product-desc {\n    color: var(--text-muted);\n  }\n\n  .Banner-container-below {\n    margin-top: 24px;\n    border-radius: 18px;\n    border: 1px solid var(--border-soft);\n    box-shadow: var(--shadow-soft);\n  }\n  \n  .tags {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 14px;\n    margin-top: 18px;\n    margin-bottom: 10px;\n    margin-left: auto;\n  }\n\n  .tag {\n    position: relative;\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 14px;\n  }\n\n  .tag i {\n    position: static;\n    font-size: 20px;\n    margin-top: 2px;\n  }\n\n  .tag-content span {\n    margin: 0;\n    font-size: 15px;\n    color: var(--text-strong);\n  }\n\n  .tag-content p {\n    margin: 0;\n    line-height: 1.45;\n    color: var(--text-muted);\n  }\n\n  .shop-now-btn,\n  .deal-cart-btn,\n  .text-add-to-cart-btn {\n    background: linear-gradient(120deg, var(--brand) 0%, var(--brand-dark) 100%);\n    color: #ffffff;\n    border: none;\n    border-radius: 10px;\n    font-weight: 650;\n  }\n\n  .shop-now-btn:hover,\n  .deal-cart-btn:hover,\n  .text-add-to-cart-btn:hover {\n    filter: brightness(1.05);\n    transform: translateY(-1px);\n  }\n\n  @media (max-width: 1024px) {\n    .tags {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .best-sell {\n      flex-direction: column;\n    }\n\n    .fixed-container {\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .featured-categories,\n    .popular-product-heading,\n    .heading-daily,\n    .deals-of-the-day,\n    .category-heading {\n      width: 94%;\n      margin-top: 24px;\n      margin-bottom: 10px;\n      font-size: 1.15rem;\n    }\n\n    .product-container,\n    .ads-product-container,\n    .column,\n    .best-sell,\n    .deals-container,\n    .selling-product,\n    .tags,\n    .Banner-container-below,\n    .category-strip {\n      width: 94%;\n    }\n\n    .slider-wrapper {\n      border-radius: 14px;\n      padding: 12px 8px;\n    }\n\n    .column {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      gap: 12px;\n    }\n\n    .product-card {\n      min-height: 250px;\n      padding: 10px;\n    }\n\n    .carousel-item {\n      min-width: 190px;\n      max-width: 190px;\n    }\n\n    .deals-container {\n      gap: 12px;\n    }\n\n    .tags {\n      grid-template-columns: 1fr;\n      gap: 10px;\n      margin-bottom: 18px;\n    }\n  }\n\n  /* ===== Premium Refinement Pass ===== */\n  body {\n    font-family: \"Manrope\", \"Segoe UI\", \"Poppins\", sans-serif;\n  }\n\n  .featured-categories,\n  .popular-product-heading,\n  .heading-daily,\n  .deals-of-the-day,\n  .category-heading {\n    position: relative;\n    padding-bottom: 6px;\n  }\n\n  .featured-categories::after,\n  .popular-product-heading::after,\n  .heading-daily::after,\n  .deals-of-the-day::after,\n  .category-heading::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 68px;\n    height: 3px;\n    border-radius: 99px;\n    background: linear-gradient(90deg, var(--brand) 0%, var(--accent) 100%);\n    opacity: 0.9;\n  }\n\n  .featured-categories,\n  .popular-product-heading,\n  .heading-daily,\n  .deals-of-the-day {\n    text-transform: none;\n    letter-spacing: 0.25px;\n  }\n\n  .product-card,\n  .product-box-ads,\n  .deal-box,\n  .carousel-item,\n  .product-category,\n  .small-product-card,\n  .fixed-container {\n    transition:\n      transform 0.25s ease,\n      box-shadow 0.25s ease,\n      border-color 0.25s ease;\n  }\n\n  .product-card:hover,\n  .product-box-ads:hover,\n  .deal-box:hover,\n  .carousel-item:hover,\n  .product-category:hover,\n  .small-product-card:hover,\n  .fixed-container:hover {\n    border-color: #c5dbef;\n  }\n\n  .product-card {\n    overflow: hidden;\n  }\n\n  .product-image,\n  .deal-image,\n  .product-box-ads img,\n  .small-product-image,\n  .carousel-item img,\n  .fixed-container img {\n    background: #f4f8fe;\n  }\n\n  .product-name,\n  .small-product-name {\n    line-height: 1.35;\n  }\n\n  .product-name:hover {\n    color: var(--brand);\n  }\n\n  .product-actions {\n    position: static;\n    opacity: 1;\n    pointer-events: auto;\n    justify-content: center;\n    gap: 8px;\n  }\n\n  .product-card:hover .product-actions {\n    opacity: 1;\n  }\n\n  .product-actions button {\n    transform: none;\n  }\n\n  .product-actions button:hover {\n    transform: translateY(-1px);\n  }\n\n  .product-icons {\n    margin-top: 8px;\n  }\n\n  .product-icons button {\n    opacity: 1;\n    pointer-events: auto;\n    transform: none;\n    width: 34px;\n    height: 34px;\n    border-radius: 9px;\n    background: #f2f7fe;\n    border: 1px solid #d7e6f5;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .product-icons button:hover {\n    background: #e6f0fb;\n    border-color: #bfd5eb;\n  }\n\n  .arrow-btn,\n  .prev,\n  .next,\n  .prev-btn,\n  .next-btn {\n    backdrop-filter: blur(3px);\n  }\n\n  .shop-now-btn,\n  .deal-cart-btn,\n  .text-add-to-cart-btn {\n    min-height: 38px;\n    letter-spacing: 0.2px;\n  }\n\n  .text-add-to-cart-btn {\n    width: 100%;\n  }\n\n  .deal-box {\n    text-align: left;\n  }\n\n  .deal-box h3,\n  .deal-price,\n  .deal-cart-btn {\n    margin-left: 4px;\n  }\n\n  .countdown {\n    margin: 12px 0;\n  }\n\n  .countdown div {\n    min-width: 52px;\n    text-align: center;\n  }\n\n  .countdown p {\n    margin: 2px 0 0;\n    font-size: 11px;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  .product-category {\n    box-shadow: 0 10px 24px rgba(17, 37, 61, 0.06);\n  }\n\n  .small-product-cards {\n    gap: 8px;\n  }\n\n  .small-product-card {\n    align-items: flex-start;\n  }\n\n  .small-product-desc {\n    line-height: 1.35;\n  }\n\n  .tag {\n    align-items: center;\n  }\n\n  .tag-content {\n    gap: 3px;\n  }\n\n  .tag-content p {\n    font-size: 13px;\n  }\n\n  @media (max-width: 768px) {\n    .product-actions {\n      gap: 6px;\n    }\n\n    .product-actions button,\n    .product-icons button {\n      width: 32px;\n      height: 32px;\n      border-radius: 8px;\n    }\n\n    .deal-box {\n      text-align: center;\n    }\n\n    .deal-box h3,\n    .deal-price,\n    .deal-cart-btn {\n      margin-left: 0;\n    }\n  }\n\n  /* Featured category slider: smooth infinite track */\n  .slider-wrapper {\n    /* --featured-gap: 14px; */\n    --featured-visible: 5;\n  }\n\n  #productSlider {\n    display: flex;\n    gap: 10px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    will-change: transform;\n  }\n\n  .product-slider .product-item {\n    flex: 0 0 calc((100% - (var(--featured-gap) * (var(--featured-visible) - 1))) / var(--featured-visible));\n    width: auto;\n  }\n\n  .product-slider .product-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .featured-product-name {\n    margin: 0;\n    font-size: 0.95rem;\n    font-weight: 700;\n    line-height: 1.35;\n    text-align: center;\n    color: var(--text-strong);\n    min-height: 2.6em;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  .featured-product-price {\n    margin: 0;\n    font-size: 0.92rem;\n    font-weight: 700;\n    color: var(--brand-dark);\n  }\n\n  .product-box-container {\n    overflow: hidden;\n  }\n\n  @media (max-width: 1024px) {\n    .slider-wrapper {\n      --featured-visible: 3;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .slider-wrapper {\n      --featured-visible: 2;\n      --featured-gap: 10px;\n    }\n\n    .featured-product-name {\n      font-size: 0.86rem;\n      min-height: 2.4em;\n    }\n\n    .featured-product-price {\n      font-size: 0.84rem;\n    }\n  }\n\n/* Featured section: left aligned + premium container */\n.featured-section {\n  text-align: left;\n  margin-top: 16px;\n}\n\n.featured-section .featured-categories {\n  width: 100%;\n  margin: 0 0 14px;\n  text-align: left;\n}\n\n.featured-slider-shell {\n  position: relative;\n  padding: 20px 44px;\n  border-radius: 20px;\n  border: 1px solid #d7e5f4;\n  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);\n  box-shadow:\n    0 18px 36px rgba(12, 33, 58, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.7);\n}\n\n.featured-section .product-box-container {\n  margin-top: 0;\n}\n\n.featured-section .product-slider .product-item {\n  border-radius: 14px;\n  background: #ffffff;\n  border: 1px solid #e1ecf8;\n  padding: 10px;\n  box-shadow: 0 8px 20px rgba(15, 41, 71, 0.06);\n}\n\n.featured-section .product-slider .product-item:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 14px 28px rgba(15, 41, 71, 0.14);\n}\n\n.featured-section .featured-product-name,\n.featured-section .featured-product-price {\n  text-align: left;\n  width: 100%;\n}\n\n.featured-section .featured-product-price {\n  margin-top: 2px;\n}\n\n@media (max-width: 768px) {\n  .featured-section .featured-categories {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .featured-slider-shell {\n    padding: 14px 34px;\n    border-radius: 14px;\n  }\n\n  .featured-section .product-slider .product-item {\n    padding: 8px;\n  }\n  .close-btn {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: transparent;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n}\n}\n\n/* Body atmosphere inspired by modern electronics storefronts */\nbody {\n  background-color: #eef4fb;\n  background-image:\n    radial-gradient(circle at 12% 6%, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 34%),\n    radial-gradient(circle at 90% 14%, rgba(189, 218, 245, 0.46) 0%, rgba(189, 218, 245, 0) 36%),\n    radial-gradient(circle at 86% 86%, rgba(215, 231, 248, 0.4) 0%, rgba(215, 231, 248, 0) 38%),\n    linear-gradient(180deg, #f9fcff 0%, #f1f6fd 52%, #edf3fb 100%);\n  background-attachment: fixed;\n  color: #13283f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
